/**
 * 配置文件
 */
// app.config.js
window.app_config = {
    /* 调试模式 */
    debugState: true,

    // Web 应用的上下文路径（默认为根路径）
    web_context_path: '',

    // 版本号
    VERSION: '1.0.0',

    // 是否启用 AJAX 加载导航
    navAsAjax: true,

    // 全局对象的引用（在浏览器环境中即 window）
    root_: $('body'),

    // 页面侧边栏中的 Logo 元素
    root_logo: $('.page-sidebar > .page-logo'),

    // 重复事件触发的延迟VAR（例如，滚动和调整事件大小）
    // 降低变量会加快响应时间，但会对CPU造成负担
    // 参考：http://benalman.com/code/projects/jquery-throttle-debounce/examples/throttle/
    throttleDelay: 450, // 用于窗口裁剪和窗口尺寸调整
    filterDelay: 250,   // 用于keyup.functions

    // 检测设备类型和浏览器环境
    thisDevice: null, // 当前设备类型：desktop（桌面）或 mobile（移动）
    isMobile: /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(navigator.userAgent.toLowerCase()), // 是否为移动设备
    mobileMenuTrigger: null, // 移动菜单触发器，供页面滚动及动态高度脚本使用
    mobileResolutionTrigger: 992, // 移动端激活的屏幕分辨率阈值

    // 检测浏览器类型
    isWebkit: 'WebkitAppearance' in document.documentElement.style, // 更简洁的 WebKit 检测
    isChrome: !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime), // Chrome 浏览器检测
    isIE: /Trident\/|MSIE/.test(navigator.userAgent),// IE 浏览器检测

    logStyleMap: {
        debug: {icon: '🐞 [DEBUG] ', style: 'color: #6b89a6; font-weight: bold;'},       // 调试信息 (Bug/调试)
        info: {icon: 'ℹ️ [INFO] ', style: 'color: #0000ff; font-weight: bold;'},        // 普通信息 (信息)
        warn: {icon: '⚠️ [WARN] ', style: 'color: #ffc241; font-weight: bold;'},        // 警告信息 (警告)
        error: {icon: '❌ [ERROR] ', style: 'color: #dc3545; font-weight: bold;'},        // 错误信息 (错误)
        success: {icon: '✅ [SUCCESS] ', style: 'color: #198754; font-weight: bold;'},      // 成功信息 (成功)
        bg_warning: {icon: '🚨 [WARN] ', style: 'background-color: #ffc241; font-weight: bold; color: #fff;'}, // 警告（带背景）
        bg_success: {icon: '🎯 [SUCCESS] ', style: 'background-color: #198754; font-weight: bold; color: #fff;'}, // 成功（带背景）
        bg_error: {icon: '💥 [ERROR] ', style: 'background-color: #ed1c24; font-weight: bold; color: #fff;'},   // 错误（带背景）
    },

    // 导航菜单配置
    navAnchor: $('#js-primary-nav'),         // 主导航锚点（更改可能影响 slimscroll 插件的目标）
    navHooks: $('#js-nav-menu'),             // 导航菜单钩子（更改可能影响 CSS 目标）
    navAccordion: true,                      // 手风琴效果，展开一个菜单时关闭其他菜单
    navInitalized: 'js-nav-built',           // 导航构建完成后的 class 标志
    navFilterInput: $('#nav_filter_input'),  // 导航过滤器输入框（更改可能影响 CSS 目标）
    navHorizontalWrapperId: 'js-nav-menu-wrapper', // 导航菜单的水平包装 ID


    // 导航菜单展开/折叠的速度（单位：ms）
    // 数值越小，子菜单展开速度越快
    navSpeed: 200,

    // 导航菜单的开/关图标（使用 FontAwesome 图标）
    navClosedSign: 'fa-solid fa-angle-down',  // 菜单关闭时的图标
    navOpenedSign: 'fa-solid fa-angle-up',    // 菜单展开时的图标

    // 日期挂载点（用于显示当前日期）
    appDateHook: $('.js-get-date'),

    // 设置存储选项
    storeLocally: true,  // 是否将设置存储到 `localStorage` 中
                         // 若要将设置存储到数据库，可使用以下方法：
                         // AppInit.pushSettings("className1 className2") // 设置值
                         // var DB_string = AppInit.getSettings(); // 返回设置字符串

    // 动态脚本/样式加载的数组（请保持为空）
    jsArray: [],          // JavaScript 脚本数组（供 `AppInit.loadScripts` 使用）
    cssArray: []          // CSS 样式数组（供 `AppInit.loadScripts` 使用）
};
/*!
 * app.logger.js
 * Logger Module
 */
(function (app, window, console) {

    'use strict';

    // ✅ 防止重复初始化
    if (app._logger_initialized) return app;

    app._logger_initialized = true;

    const noop = function () {
    };

    const debug = window.app_config && window.app_config.debugState === true;

    const styles = {
        info: 'color:#0d6efd',
        warn: 'color:#fd7e14',
        error: 'color:#dc3545',
        success: 'color:#198754'
    };

    const format = function (prefix, args) {
        return [
            `%c${prefix}`,
            styles[prefix.toLowerCase()] || ''
        ].concat(
            Array.prototype.slice.call(args)
        );
    }

    // 是否处于本地/内网调试环境
    const isLocalEnv = (() => {
        // Node / SSR 环境没有 window，交给 debug 单独把关
        if (typeof window === 'undefined' || !window.location) return true;

        const h = window.location.hostname;
        return (
            h === 'localhost' ||
            h === '127.0.0.1' ||
            h === '::1' ||
            h === '' ||                                 // file:// 直接打开
            /\.local$/i.test(h) ||                      // xxx.local
            /^192\.168\./.test(h) ||                    // 内网
            /^10\./.test(h) ||
            /^172\.(1[6-9]|2\d|3[01])\./.test(h)
        );
    })();


    // 总开关：debug 打开 且 在本地环境
    const enableLog = (debug && isLocalEnv);

    app.logger = {
        info() {
            if (!enableLog) return;
            console.info.apply(
                console,
                format('INFO', arguments)
            );
        },
        warn() {
            if (!enableLog) return;
            console.warn.apply(
                console,
                format('WARN', arguments)
            );
        },

        error() {
            console.error.apply(
                console,
                format('ERROR', arguments)
            );
        },

        success() {
            if (!enableLog) return;
            console.log.apply(
                console,
                format('SUCCESS', arguments)
            );
        },

        table(data) {
            if (!enableLog) return;
            console.table(data);
        },

        group(title) {
            if (!enableLog) return;
            console.group(title);
        },

        groupEnd() {
            if (!enableLog) return;
            console.groupEnd();
        }
    };

})(window.MyApp = window.MyApp || {}, window, window.console);
/*!
* jQuery app.navigation
*/
(function ($) {
    /**
     * 菜单插件
     */
    $.fn.extend({
        /**
         * 传入参数对象来初始化菜单
         *
         *   $(id).navigation({
         *       accordion: true, // 是否启用手风琴模式
         *       animate: 'easeOutExpo', // 动画效果
         *       speed: 200, // 动画速度
         *       closedSign: '[+]', // 关闭状态标志
         *       openedSign: '[-]', // 打开状态标志
         *       initClass: 'js-nav-built' // 初始化标识类
         *   });
         */
        navigation: function (options) {
            const defaults = {
                    accordion: true,
                    animate: 'swing',
                    speed: 200,
                    closedSign: '[+]',
                    openedSign: '[-]',
                    initClass: 'js-nav-built'
                },
                // 合并默认配置与用户传入的配置
                opts = $.extend({}, defaults, options),
                // 目标元素 (通常是 `ul`)
                self = $(this);

            // 检查菜单是否已经初始化，避免重复绑定
            if (!self.hasClass(opts.initClass)) {
                self.addClass(opts.initClass); // 添加初始化类
                /**
                 * 遍历 `li`，为包含子菜单的项添加关闭符号
                 */
                self.find("li").each(function () {
                    const $li = $(this);
                    if ($li.find("ul").length > 0) {
                        // 在 `a` 标签后追加 `b` 元素作为展开/折叠标志
                        $li.find("a:first").append("<b class='collapse-sign'>" + opts.closedSign + "</b>");

                        // 如果 `href="#"`，阻止默认行为
                        if ($li.find("a:first").attr('href') === "#") {
                            $li.find("a:first").on("click", function (e) {
                                e.preventDefault();
                            });
                        }
                    }
                });

                /**
                 * 处理 `active` 状态的 `li`，展开父级菜单
                 */
                self.find("li.active").each(function () {
                    $(this).parents("ul")
                        .parent("li")
                        .find("a:first")
                        .attr('aria-expanded', true)
                        .find("b:first")
                        .html(opts.openedSign);
                });

                /**
                 * 绑定点击事件
                 */
                self.find("li a").on('mousedown', function (e) {
                    const $anchor = $(this),
                        $parentLi = $anchor.parent(),
                        $submenu = $parentLi.find("ul:first");
                    if ($submenu.length > 0) {
                        if (opts.accordion) {
                            /// 仅在当前菜单项未展开时执行
                            if (!$submenu.is(':visible')) {
                                const parents = $parentLi.parents("ul");
                                const visibleSubmenus = self.find("ul:visible");

                                visibleSubmenus.each(function () {
                                    let close = true;
                                    const $visibleMenu = $(this);
                                    // 检查当前菜单是否属于打开的父级菜单
                                    parents.each(function () {
                                        if (this === $visibleMenu[0]) {
                                            close = false;
                                            return false; // 终止 `each`
                                        }
                                    });

                                    // 关闭不相关的菜单
                                    if (close) {
                                        $visibleMenu.slideUp(opts.speed + 300, opts.animate, function () {
                                            $(this).parent("li")
                                                .removeClass("open")
                                                .find("a:first")
                                                .attr('aria-expanded', false)
                                                .find("b:first")
                                                .html(opts.closedSign);
                                        });
                                    }
                                });
                            }
                        }

                        // 切换当前菜单项的展开/折叠状态
                        if ($submenu.is(":visible")) {
                            $submenu.slideUp(opts.speed + 100, opts.animate, function () {
                                $parentLi.removeClass("open")
                                    .find("a:first")
                                    .attr('aria-expanded', false)
                                    .find("b:first").html(opts.closedSign);
                            });
                        } else {
                            $submenu.slideDown(opts.speed, opts.animate, function () {
                                $parentLi.addClass("open")
                                    .find("a:first")
                                    .attr('aria-expanded', true)
                                    .find("b:first").html(opts.openedSign);
                            });
                        }
                        return false; // 防止 `a` 标签默认事件
                    }
                });
            } else {
                if (window.app_config?.debugState)
                    console.log(`%c${self.get(0)} 此菜单已存在`, app_config.logStyleMap.info.style);
            }
        },

        /**
         * 销毁菜单
         * 使用方式： $(id).navigationDestroy();
         */
        navigationDestroy: function () {
            var self = $(this);
            let nav_built_class = app_config.navInitalized || 'js-nav-built';
            if (self.hasClass(nav_built_class)) {
                self.find("li").removeClass("active open");
                self.find("li a")
                    .off('mousedown')
                    .removeClass("active")
                    .removeAttr("aria-expanded")
                    .find(".collapse-sign")
                    .remove();
                self.removeClass(nav_built_class).find("ul").removeAttr("style");

                if (app_config.debugState)
                    console.log(`%c${self.get(0)} 菜单已销毁`, app_config.logStyleMap.error.style);

            } else {
                console.log(`%c${self.get(0)} 菜单不存在`, app_config.logStyleMap.error.style);
            }
        }
    });

})(jQuery, window, document);
/*!
* jQuery app.swipe-nav
*/
(function ($) {
    /**
     * 菜单滑动插件
     */
    $.fn.extend({
        swipeNavigation: function (options) {
            const defaults = {
                threshold: 80,          // 触发距离
                maxTime: 500,           // 最大滑动时间
                touchArea: null,
                edgeZone: 50,
                enableEdgeOnly: false,
                bodySelector: 'body'
            };

            const opts = $.extend({}, defaults, options);
            const $touchArea = opts.touchArea ? $(opts.touchArea) : $(document);
            const $body = $(opts.bodySelector);

            let startX = 0;
            let startY = 0;
            let startTime = 0;
            let isHorizontal = false;
            let isValidStart = true;

            const NS = '.swipeNav';

            function onStart(e) {
                const touch = e.originalEvent.touches[0];

                startX = touch.clientX;
                startY = touch.clientY;
                startTime = Date.now();
                isHorizontal = false;


                isValidStart = !(opts.enableEdgeOnly && startX > opts.edgeZone);
            }

            function onMove(e) {
                if (!isValidStart) return;

                const touch = e.originalEvent.touches[0];
                const dx = touch.clientX - startX;
                const dy = touch.clientY - startY;

                // 一旦确定方向就锁定
                if (!isHorizontal) {
                    if (Math.abs(dx) > Math.abs(dy)) {
                        isHorizontal = true;
                    } else {
                        isValidStart = false; // 竖向直接取消
                    }
                }
            }

            function onEnd(e) {
                if (!isValidStart || !isHorizontal) return;

                const touch = e.originalEvent.changedTouches[0];
                const dx = touch.clientX - startX;
                const dt = Date.now() - startTime;

                if (Math.abs(dx) > opts.threshold && dt < opts.maxTime) {
                    if (dx > 0) {
                        // 👉 右滑
                        if (!$body.hasClass('mobile-nav-on')) {
                            $body.addClass('mobile-nav-on');
                            console.log('👉 open nav');
                        }
                    } else {
                        // 👈 左滑
                        if ($body.hasClass('mobile-nav-on')) {
                            $body.removeClass('mobile-nav-on');
                            console.log('👈 close nav');
                        }
                    }
                }

                reset();
            }

            function reset() {
                startX = 0;
                startY = 0;
                isHorizontal = false;
                isValidStart = true;
            }

            $touchArea
                .on('touchstart' + NS, onStart)
                .on('touchmove' + NS, onMove)
                .on('touchend' + NS, onEnd);

            this.data('swipeNavArea', $touchArea);

            return this;
        },

        swipeNavigationDestroy: function () {
            const $area = this.data('swipeNavArea') || $(document);
            $area.off('.swipeNav');
            return this;
        }
    });

})(jQuery, window, document);

;(function ($) {
    const pluginName = 'menuSlider';

    function Plugin(element, options) {

        let $el = $(element),
            el = element;
        options = $.extend({}, $.fn[pluginName].defaults, options);

        function init() {

            console.log('menuSlider init');

            /* reset margin */
            $el.css('margin-left', '0px');

            /* add wrapper around navigation */
            $el.wrap('<div id="' + options.wrapperId + '" class="nav-menu-wrapper d-flex flex-grow-1 width-0 overflow-hidden"></div>');

            /* add buttons for scroller */
            const $wrapper = $('#' + options.wrapperId);
            $wrapper.before('<a href="#" id="' + options.wrapperId + '-left-btn" class="d-flex align-items-center justify-content-center width-4 btn my-1 mx-2 p-0 fs-xxl text-primary"><i class="fas fa-angle-left"></i></a>');
            $wrapper.after('<a href="#" id="' + options.wrapperId + '-right-btn" class="d-flex align-items-center justify-content-center width-4 btn my-1 mx-2 p-0 fs-xxl text-primary"><i class="fas fa-angle-right"></i></a>');

            let getListWidth = $.map($el.children('li:not(.nav-title)'), function (val) {
                    return $(val).outerWidth(true);
                }),
                /* define variables */
                wrapperWidth,
                currentMarginLeft,
                contentWidth,
                setMargin,
                maxMargin,


                /* update variables for margin calculations */
                _getValues = function () {
                    wrapperWidth = $wrapper.outerWidth(); /* incase its changed we get it again */
                    contentWidth = $.map($el.children('li:not(.nav-title)'), function (val) {
                        return $(val).outerWidth(true);
                    }).reduce(function (a, b) {
                        return a + b;
                    }, 0);
                    currentMarginLeft = parseFloat($el.css('margin-left'));

                    /*console.log("got new values");
                    console.log("wrapperWidth :" + wrapperWidth);
                    console.log("contentWidth :" + contentWidth);
                    console.log("currentMarginLeft :" + currentMarginLeft);*/
                },

                /* scroll right */
                navMenuScrollRight = function () {

                    _getValues();

                    if (-currentMarginLeft + wrapperWidth < contentWidth) {
                        setMargin = Math.max(currentMarginLeft - wrapperWidth, -(contentWidth - wrapperWidth));
                    } else {
                        setMargin = currentMarginLeft;
                        console.log("right end");
                    }

                    $el.css({
                        marginLeft: setMargin
                    });

                },

                /* scroll left */
                navMenuScrollLeft = function () {

                    _getValues();

                    if (currentMarginLeft < 0) {
                        setMargin = Math.min(currentMarginLeft + wrapperWidth, 0);
                    } else {
                        setMargin = currentMarginLeft;
                        console.log("left end");
                    }

                    $el.css({
                        marginLeft: setMargin
                    });

                };

            /* assign buttons for right*/
            $('#' + options.wrapperId + '-left-btn').click(function (e) {

                navMenuScrollLeft();

                e.preventDefault();
            });

            /* assign buttons for left */
            $('#' + options.wrapperId + '-right-btn').click(function (e) {

                navMenuScrollRight();

                e.preventDefault();
            });

            hook('onInit');
        }

        function option(key, val) {
            if (val) {
                options[key] = val;
            } else {
                return options[key];
            }
        }

        function destroy(options) {
            $el.each(function () {
                let el = this;
                let $el = $(this);

                // Add code to restore the element to its original state...

                $el.css('margin-left', '0px');
                $el.unwrap(parent);
                $el.prev().off().remove();
                $el.next().off().remove();

                hook('onDestroy');
                $el.removeData('plugin_' + pluginName);
            });
        }

        function hook(hookName) {
            if (options[hookName] !== undefined) {
                options[hookName].call(el);
            }
        }

        init();

        return {
            option: option,
            destroy: destroy
        };
    }

    $.fn[pluginName] = function (options) {
        if (typeof arguments[0] === 'string') {
            let methodName = arguments[0];
            let args = Array.prototype.slice.call(arguments, 1);
            let returnVal;
            this.each(function () {
                if ($.data(this, 'plugin_' + pluginName) && typeof $.data(this, 'plugin_' + pluginName)[methodName] === 'function') {
                    returnVal = $.data(this, 'plugin_' + pluginName)[methodName].apply(this, args);
                } else {
                    throw new Error('Method ' + methodName + ' does not exist on jQuery.' + pluginName);
                }
            });
            if (returnVal !== undefined) {
                return returnVal;
            } else {
                return this;
            }
        } else if (typeof options === "object" || !options) {
            return this.each(function () {
                if (!$.data(this, 'plugin_' + pluginName)) {
                    $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
                }
            });
        }
    };

    $.fn[pluginName].defaults = {
        onInit: function () {
        },
        onDestroy: function () {
        },
        element: app_config.navHooks,
        wrapperId: app_config.navHorizontalWrapperId
    };


})(jQuery);
/*!
 * app.utils.js
 */
(function (app, window, document, $) {

    'use strict';

    if (!$) throw new Error('jQuery is required');

    // 如果已经初始化，跳过
    if (app._utils_initialized) return app;

    app._utils_initialized = true;

    // namespace
    // =========================================================
    app.utils = app.utils || {};

    /**
     * Number Utils
     * =========================================================
     */
    app.utils.number = {

        toNumber(value, defaultValue = 0) {
            const n = Number(value);
            return Number.isFinite(n) ? n : defaultValue;
        },

        floatAdd(arg1, arg2) {
            const r1 = (arg1.toString().split('.')[1] || '').length;
            const r2 = (arg2.toString().split('.')[1] || '').length;
            const m = Math.pow(10, Math.max(r1, r2));

            return (arg1 * m + arg2 * m) / m;
        },

        floatSub(arg1, arg2) {
            const r1 = (arg1.toString().split('.')[1] || '').length;
            const r2 = (arg2.toString().split('.')[1] || '').length;
            const m = Math.pow(10, Math.max(r1, r2));

            return (arg1 * m - arg2 * m) / m;
        },

        floatMul(arg1, arg2) {
            let m = 0;

            const s1 = arg1.toString();
            const s2 = arg2.toString();

            m += (s1.split('.')[1] || '').length;
            m += (s2.split('.')[1] || '').length;

            return Number(s1.replace('.', ''))
                * Number(s2.replace('.', ''))
                / Math.pow(10, m);
        },

        floatDiv(arg1, arg2) {

            if (Number(arg2) === 0) {
                return 0;
            }

            const t1 = (arg1.toString().split('.')[1] || '').length;
            const t2 = (arg2.toString().split('.')[1] || '').length;

            const r1 = Number(arg1.toString().replace('.', ''));
            const r2 = Number(arg2.toString().replace('.', ''));

            return (r1 / r2) * Math.pow(10, t2 - t1);
        },

        format(number, decimals = 2, decPoint = '.', thousandsSep = ',') {
            const n = this.toNumber(number);
            const fixed = n.toFixed(decimals);
            const parts = fixed.split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
            return parts.join(decPoint);
        },

    };

    /**
     * Currency Utils
     * =========================================================
     */
    app.utils.currency = {

        upperCase(money) {

            if (money === null || money === undefined || money === '') {
                return '';
            }

            // 可以直接复用你原来的 upperCaseCurrency
            return app.utils.currency._convert(money);
        },

        _convert(money) {
            // Constants:
            const MAXIMUM_NUMBER = 99999999999.99;

            //region // Predefine the radix characters and currency symbols for output:
            const CN_ZERO = "零";
            const CN_ONE = "壹";
            const CN_TWO = "贰";
            const CN_THREE = "叁";
            const CN_FOUR = "肆";
            const CN_FIVE = "伍";
            const CN_SIX = "陆";
            const CN_SEVEN = "柒";
            const CN_EIGHT = "捌";
            const CN_NINE = "玖";
            const CN_TEN = "拾";
            const CN_HUNDRED = "佰";
            const CN_THOUSAND = "仟";
            const CN_TEN_THOUSAND = "万";
            const CN_HUNDRED_MILLION = "亿";
            const CN_SYMBOL = "人民币";
            const CN_DOLLAR = "元";
            const CN_TEN_CENT = "角";
            const CN_CENT = "分";
            const CN_INTEGER = "整";
            //endregion

            // Variables:
            let integral; // Represent integral part of digit number.
            let decimal; // Represent decimal part of digit number.
            let outputCharacters; // The output result.
            let parts;
            let digits, radices, bigRadices, decimals;
            let zeroCount;
            let i, p, d;
            let quotient, modulus;
            // Validate input string:
            money = money.toString();
            if (money === '') {
                return '';
            }
            if (money.match(/^([-+])?\d+(\.[0-9]{1,4})?$/) == null) {
                return '';
            }
            // Normalize the format of input digits:
            money = money.replace(/,/g, ""); // Remove comma
            // delimiters.
            money = money.replace(/^0+/, ""); // Trim zeros at the
            // beginning.
            // Assert the number is not greater than the maximum number.
            if (Number(money) > MAXIMUM_NUMBER) {
                return '金额超出范围';
            }
            // Process the coversion from currency digits to characters:
            // Separate integral and decimal parts before processing coversion:
            parts = money.split('.');
            if (parts.length > 1) {
                integral = parts[0];
                decimal = parts[1];
                // Cut down redundant decimal digits that are after the second.
                decimal = decimal.substr(0, 2);
            } else {
                integral = parts[0];
                decimal = '';
            }
            // Prepare the characters corresponding to the digits:
            digits = [CN_ZERO, CN_ONE, CN_TWO, CN_THREE, CN_FOUR, CN_FIVE, CN_SIX, CN_SEVEN, CN_EIGHT, CN_NINE];
            radices = ['', CN_TEN, CN_HUNDRED, CN_THOUSAND];
            bigRadices = ['', CN_TEN_THOUSAND, CN_HUNDRED_MILLION];
            decimals = [CN_TEN_CENT, CN_CENT];
            // Start processing:
            outputCharacters = '';
            // Process integral part if it is larger than 0:

            let integral_val = Number(integral);
            if (integral_val < 0) {
                outputCharacters = '负';
                integral_val = -integral_val;
                integral = integral.replace('-', '');
            }
            if (integral_val > 0) {
                zeroCount = 0;
                for (i = 0; i < integral.length; i++) {
                    p = integral.length - i - 1;
                    d = integral.substr(i, 1);
                    quotient = p / 4;
                    modulus = p % 4;
                    if (d === "0") {
                        zeroCount++;
                    } else {
                        if (zeroCount > 0) {
                            outputCharacters += digits[0];
                        }
                        zeroCount = 0;
                        outputCharacters += digits[Number(d)] + radices[modulus];
                    }
                    if (modulus === 0 && zeroCount < 4) {
                        outputCharacters += bigRadices[quotient];
                    }
                }
                outputCharacters += CN_DOLLAR;
            }
            // Process decimal part if there is:
            if (decimal !== "") {
                for (i = 0; i < decimal.length; i++) {
                    d = decimal.substr(i, 1);
                    if (d !== "0") {
                        outputCharacters += digits[Number(d)] + decimals[i];
                    } else {
                        outputCharacters += "零" + decimals[i];
                    }
                }
            }
            // Confirm and return the final output string:
            if (outputCharacters === "") {
                outputCharacters = CN_ZERO + CN_DOLLAR;
            }
            if (decimal === "") {
                outputCharacters += CN_INTEGER;
            }
            // outputCharacters = CN_SYMBOL + outputCharacters;
            return outputCharacters;
        }
    };

    /**
     * Date Utils
     * =========================================================
     */
    app.utils.date = {

        now() {
            return Date.now();
        },

        today() {
            const d = new Date();
            d.setHours(0, 0, 0, 0);
            return d;
        },

        yesterday() {
            return this.addDays(this.today(), -1);
        },

        tomorrow() {
            return this.addDays(this.today(), 1);
        },

        startOfWeek() {

            const d = this.today();

            const day = d.getDay() || 7;

            d.setDate(d.getDate() - day + 1);

            return d;
        },

        startOfMonth() {

            const d = this.today();

            d.setDate(1);

            return d;
        },

        addMinutes(date, minutes) {
            return new Date(date.getTime() + minutes * 60000);
        },

        addHours(date, hours) {
            return new Date(date.getTime() + hours * 3600000);
        },

        addDays(date, days) {
            const d = new Date(date);
            d.setDate(d.getDate() + days);
            return d;
        },

        addWeeks(date, weeks) {
            return this.addDays(date, weeks * 7);
        },

        addMonths(date, months) {

            const d = new Date(date);

            const day = d.getDate();

            d.setMonth(d.getMonth() + months);

            if (d.getDate() < day) {
                d.setDate(0);
            }

            return d;
        },

        addYears(date, years) {

            const d = new Date(date);

            d.setFullYear(d.getFullYear() + years);

            return d;
        },

        format(date, withTime = true) {

            if (!(date instanceof Date)) {
                return '';
            }

            const pad = (n) => String(n).padStart(2, '0');

            const str = [
                date.getFullYear(),
                pad(date.getMonth() + 1),
                pad(date.getDate())
            ].join('-');

            if (!withTime) {
                return str;
            }

            return `${str} ${
                [
                    pad(date.getHours()),
                    pad(date.getMinutes()),
                    pad(date.getSeconds())
                ].join(':')
            }`;
        },

        isSameDay(d1, d2) {

            return d1.getFullYear() === d2.getFullYear()
                && d1.getMonth() === d2.getMonth()
                && d1.getDate() === d2.getDate();
        },

        isTimeBetween(startTime, endTime) {

            const now = new Date();

            const current = now.getHours() * 60 + now.getMinutes();

            const [sh, sm] = startTime.split(':').map(Number);
            const [eh, em] = endTime.split(':').map(Number);

            const start = sh * 60 + sm;
            const end = eh * 60 + em;

            if (end < start) {
                return current >= start || current <= end;
            }

            return current >= start && current <= end;
        }
    };

    app.utils.func = {
        /**
         * 防抖
         * @param {Function} fn
         * @param {number} delay
         * @returns {Function}
         */
        debounce(fn, delay = 300) {
            if (typeof fn !== 'function') {
                throw new TypeError('debounce fn must be a function');
            }

            let timer = null;

            return function (...args) {
                const context = this;
                clearTimeout(timer);
                timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            };
        },

        /**
         * 节流
         * @param {Function} fn
         * @param {number} wait
         * @returns {Function}
         */
        throttle(fn, wait = 300) {
            if (typeof fn !== 'function') {
                throw new TypeError('throttle fn must be a function');
            }
            let lastTime = 0;
            return function (...args) {
                const now = Date.now();
                if (now - lastTime >= wait) {
                    lastTime = now;
                    fn.apply(this, args);
                }
            };
        }
    };

})(window.MyApp = window.MyApp || {}, window, document, jQuery);

/*!
 * TaskScheduler
 */
window.TaskScheduler = window.TaskScheduler || (function (app) {

    class Scheduler {

        constructor(taskFn, interval = 1000, options = {}) {
            if (typeof taskFn !== 'function') {
                throw new TypeError('taskFn must be a function');
            }

            this.taskFn = taskFn;
            this.interval = this._normalizeInterval(interval);
            this.immediate = options.immediate === true;

            this.timer = null;
            this.running = false;
            this.executing = false;
        }

        start() {
            if (this.running) {
                return this;
            }

            this.running = true;

            if (this.immediate) {
                this._execute().then(r => {
                });
            } else {
                this._schedule();
            }

            return this;
        }

        stop() {
            this.running = false;

            if (this.timer !== null) {
                clearTimeout(this.timer);
                this.timer = null;
            }

            return this;
        }

        restart() {
            return this.stop().start();
        }

        isRunning() {
            return this.running;
        }

        setInterval(interval) {
            this.interval = this._normalizeInterval(interval);

            if (this.running && !this.executing) {
                this._schedule();
            }

            return this;
        }

        async _execute() {
            if (!this.running || this.executing) {
                return;
            }

            this.executing = true;

            try {
                await this.taskFn();
            } catch (error) {
                console.error('[TaskScheduler] task error:', error);
            } finally {
                this.executing = false;

                if (this.running) {
                    this._schedule();
                }
            }
        }

        _schedule() {
            if (!this.running) {
                return;
            }

            if (this.timer !== null) {
                clearTimeout(this.timer);
            }

            this.timer = setTimeout(() => {
                this.timer = null;
                this._execute().then(r => {
                });
            }, this.interval);
        }

        _normalizeInterval(interval) {
            interval = Number(interval);

            if (!Number.isFinite(interval) || interval <= 0) {
                throw new TypeError('interval must be a positive number');
            }

            return interval;
        }
    }

    app.Scheduler = Scheduler;

    app.createScheduler = function (taskFn, interval, options) {
        return new Scheduler(taskFn, interval, options);
    };

    return app;

})(window.MyApp = window.MyApp || {});
/*!
 * App 初始化
 */
window.AppInit = window.AppInit || (function (app, config) {

    // ==================== 配置与工具函数 ====================

    /**
     * 安全获取配置值
     * @param {string} key - 配置键名
     * @param {*} defaultValue - 默认值
     * @returns {*}
     */
    const getConfig = function (key, defaultValue) {
        return (app_config && app_config[key] !== undefined)
            ? app_config[key]
            : defaultValue;
    };

    /**
     * 调试日志输出（仅在 debugState 开启时输出）
     * @param {string} level - 日志级别
     * @param {string} msg - 日志消息
     * @param {*} [data] - 附加数据
     */
    const debugLog = function (level, msg, data) {
        if (getConfig('debugState', false)) {
            if (data !== undefined) {
                console.debug(`[${level}] ${msg}`, data);
            } else {
                app.log(level, msg);
            }
        }
    };

    /**
     * 安全执行回调函数（支持同步/异步）
     * @param {Function|null} fn 回调函数
     * @param {...*} args 回调参数
     * @returns {Promise<*>}
     */
    const safeCallback = async function (fn, ...args) {
        if (typeof fn !== 'function')
            return null;

        try {
            // 支持同步函数和 async 函数
            return await Promise.resolve(fn(...args));
        } catch (err) {
            console.error('Callback execution error:', err);
            // 调试模式输出日志
            if (typeof app !== 'undefined'
                && typeof getConfig === 'function'
                && getConfig('debugState', false)
            ) {
                app.log('error', err.message || 'Callback execution error');
            }
            // 建议继续抛出，交给调用者处理
            throw err;
        }
    };

    /**
     * HTML 转义（防止 XSS）
     * @param {string} str - 原始字符串
     * @returns {string}
     */
    app.escapeHtml = app.escapeHtml || function (str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };

    /**
     * 解码 HTML 实体
     * @param {string} str - 编码的字符串
     * @returns {string}
     */
    const decodeHtmlEntities = function (str) {
        if (!str) return '';
        return str.replace(/\\u([\dA-F]{4})/gi, function (match, grp) {
            return String.fromCharCode(parseInt(grp, 16));
        });
    };

    // ==================== 原有方法（优化版） ====================
    app.context_path = app_config.web_context_path || '';

    /**
     * 日志输出函数
     * @param {string} level - 日志级别 (info, warn, error, success, debug)
     * @param {string} msg - 日志消息
     */
    app.log = function (level, msg) {
        const levelMap = {
            info: "ℹ️",     // 信息
            warn: "⚠️",     // 警告
            error: "❌",    // 错误
            success: "✅",  // 成功
            debug: "🐞"     // 调试
        };

        const colorMap = {
            info: "#6b89a6",   // 信息颜色
            warn: "#ffc107",   // 警告颜色
            error: "#dc3545",  // 错误颜色
            success: "#198754",// 成功颜色
            debug: "#6f42c1"   // 调试颜色
        };

        const icon = levelMap[level] || "🔹";
        const color = colorMap[level] || "#000";

        console.log(`%c${icon} [${level.toUpperCase()}] ${msg}`, `color: ${color}; font-weight: bold;`);
    };

    /**
     * 通用日志输出（支持多种样式）
     * @param {string} message - 日志消息，使用 `%c` 标记样式插入点
     * @param {...string} styles - CSS 样式
     */
    app.debug = function (message, ...styles) {
        const styleCount = (message.match(/%c/g) || []).length;
        while (styles.length < styleCount) {
            styles.push('');
        }
        console.log(message, ...styles);
    };

    /**
     * 检测访问设备是 PC 还是手机，并添加对应的设备类型标识
     */
    app.addDeviceType = function () {
        if (!app_config.isMobile) {
            app_config.root_.addClass('desktop');
            app_config.thisDevice = 'desktop';
        } else {
            app_config.root_.addClass('mobile');
            app_config.thisDevice = 'mobile';
        }
        debugLog("success", "The device is a " + app_config.thisDevice);
    };
    /**
     * 检测浏览器类型和内核
     */
    app.detectBrowserType = function () {
        if (app_config.isChrome) {
            app_config.root_.addClass('chrome webkit');
            debugLog("success", "The browser type is Chrome with Webkit");
        } else if (app_config.isWebkit) {
            app_config.root_.addClass('webkit');
            debugLog("success", "The browser type is Webkit");
        } else if (app_config.isIE) {
            app_config.root_.addClass('ie');
            debugLog("success", "The browser type is IE");
        } else {
            debugLog("warn", "Unknown or unsupported browser");
        }
    };

    /**
     * 激活手机浏览模式
     * DOC: 当屏幕宽度 小于设定值是（默认992px）激活手机浏览模式
     */
    app.mobileCheckActivation = function () {
        const isMobileActive = window.innerWidth < getConfig('mobileResolutionTrigger', 992);

        if (isMobileActive) {
            app_config.root_.addClass('mobile-view-activated');
            app_config.mobileMenuTrigger = true;
        } else {
            app_config.root_.removeClass('mobile-view-activated');
            app_config.mobileMenuTrigger = false;
        }

        debugLog('success', 'mobileCheckActivation on ' + $(window).width() + ' | activated: ' + app_config.mobileMenuTrigger);
    };

    /**
     * 激活导航栏
     * @param {string} id - 选择器 ID
     */
    app.buildNavigation = function (id) {
        if ($.fn.navigation) {
            app.log('info', '正在初始化导航栏');
            $(id).navigation({
                accordion: app_config.navAccordion,
                speed: app_config.navSpeed,
                closedSign: '<em class="' + app_config.navClosedSign + '"></em>',
                openedSign: '<em class="' + app_config.navOpenedSign + '"></em>',
                initClass: app_config.navInitalized
            });
        } else {
            debugLog('warn', 'navigation 插件缺失');
        }
    };

    /**
     * 导航检索
     * @param {string|jQuery} list - 列表容器
     * @param {string|jQuery} input - 输入框
     * @param {string|jQuery} [anchor] - 锚点容器
     */
    app.listFilter = function (list, input, anchor) {
        const $list = $(list);
        const $input = $(input);
        const $anchor = anchor ? $(anchor) : null;

        ($anchor || $list).addClass('js-list-filter');

        const $messageContainer = $list.next('.js-filter-message');

        /**
         * 执行筛选
         * @param {string} filterText
         */
        const performFilter = function (filterText) {

            const filter = (filterText || '').toLowerCase().trim();

            const $items = $list.find('[data-filter-tags]');
            const $allLi = $list.find('li');

            // 清空状态
            $allLi.removeClass('js-filter-show js-filter-hide');

            // 输入不足2个字符时恢复
            if (filter.length <= 1) {
                if ($messageContainer.length) {
                    $messageContainer.text('');
                }
                return;
            }

            let visibleCount = 0;

            $items.each(function () {
                const $item = $(this);
                const tags = String(
                    $item.attr('data-filter-tags') || ''
                ).toLowerCase();

                if (!tags.includes(filter)) {
                    return;
                }
                visibleCount++;
                // 当前菜单项
                const $li = $item.closest('li');
                // 显示当前节点
                $li.addClass('js-filter-show')
                    .removeClass('js-filter-hide');

                // 显示所有父级菜单
                $li.parents('li')
                    .addClass('js-filter-show')
                    .removeClass('js-filter-hide');

                // 展开父级 ul
                $li.parents('ul')
                    .show();
            });

            // 未命中的菜单全部隐藏
            $allLi.not('.js-filter-show')
                .addClass('js-filter-hide');

            if ($messageContainer.length) {
                $messageContainer.text(
                    `显示 ${visibleCount} 项`
                );
            }
        };

        const delay = getConfig('filterDelay', 250);
        const debouncedFilter = app.utils.func.debounce(performFilter, delay);

        $input
            .off('.listFilter')
            .on('input.listFilter', function () {
                debouncedFilter(this.value);
            });

        $input.on('keyup.listFilter', function (e) {

            if (e.key === 'Enter') {

                const visibleLinks = $list.find(
                    'li.js-filter-show > a'
                );

                debugLog(
                    'info',
                    '筛选结果数量:',
                    visibleLinks.length
                );
            }
        });

        // 初始值处理
        const initialValue = $input.val();

        if (initialValue && initialValue.length > 1) {
            performFilter(initialValue);
        }
    };

    /**
     * 动态加载脚本（支持重试）
     * @param {string} scriptName - 脚本路径
     * @param {Function} [callback] - 回调函数
     * @param {number} [retries=2] - 重试次数
     * @returns {Promise}
     */
    app.loadScript = function (scriptName, callback, retries = 2) {
        const loadPromise = function () {
            if (app_config.jsArray[scriptName]) {
                debugLog('success', 'This script was already loaded: ' + scriptName);
                return app_config.jsArray[scriptName];
            }

            app_config.jsArray[scriptName] = new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.type = 'text/javascript';
                script.src = scriptName;
                script.async = true;
                script.defer = true;

                const timeout = setTimeout(function () {
                    reject(new Error('Script load timeout: ' + scriptName));
                }, 30000);

                script.onload = function () {
                    clearTimeout(timeout);
                    debugLog('success', 'Script loaded: ' + scriptName);
                    resolve();
                };

                script.onerror = function (error) {
                    clearTimeout(timeout);
                    console.error('Failed to load script:', scriptName, error);
                    reject(new Error('Script load failed: ' + scriptName));
                };

                document.head.appendChild(script);
            });

            return app_config.jsArray[scriptName];
        };

        const attempt = function (remaining) {
            return loadPromise().catch(function (err) {
                if (remaining > 0) {
                    debugLog('warn', 'Retrying script: ' + scriptName + ' (' + remaining + ' left)');
                    delete app_config.jsArray[scriptName];
                    return attempt(remaining - 1);
                }
                throw err;
            });
        };

        return attempt(retries).then(function () {
            return safeCallback(callback);
        }).catch(function (err) {
            delete app_config.jsArray[scriptName];
            if (getConfig('debugState', false)) {
                console.error(err);
                app.log('error', 'Script load failed: ' + scriptName);
            }
        });
    };

    /**
     * 动态加载样式（支持重试）
     * @param {string} styleName - 样式路径
     * @param {Function} [callback] - 回调函数
     * @param {number} [retries=2] - 重试次数
     * @returns {Promise}
     */
    app.loadStyle = function (styleName, callback, retries = 2) {
        const loadPromise = function () {
            if (app_config.cssArray[styleName]) {
                debugLog('success', 'This style was already loaded: ' + styleName);
                return app_config.cssArray[styleName];
            }

            app_config.cssArray[styleName] = new Promise((resolve, reject) => {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = styleName;

                const timeout = setTimeout(function () {
                    reject(new Error('Style load timeout: ' + styleName));
                }, 30000);

                link.onload = function () {
                    clearTimeout(timeout);
                    debugLog('success', 'Style loaded: ' + styleName);
                    resolve();
                };

                link.onerror = function (error) {
                    clearTimeout(timeout);
                    console.error('Failed to load style:', styleName, error);
                    reject(new Error('Style load failed: ' + styleName));
                };

                document.head.appendChild(link);
            });

            return app_config.cssArray[styleName];
        };

        const attempt = function (remaining) {
            return loadPromise().catch(function (err) {
                if (remaining > 0) {
                    debugLog('warn', 'Retrying style: ' + styleName + ' (' + remaining + ' left)');
                    delete app_config.cssArray[styleName];
                    return attempt(remaining - 1);
                }
                throw err;
            });
        };

        return attempt(retries).then(function () {
            return safeCallback(callback);
        }).catch(function (err) {
            delete app_config.cssArray[styleName];
            if (getConfig('debugState', false)) {
                console.error(err);
                app.log('error', 'Style load failed: ' + styleName);
            }
            throw err;
        });
    };

    /**
     * 串行批量加载脚本
     * @param {Array} scripts 脚本数组（字符串或 {url, callback}）
     * @param {Function} [onProgress] 进度回调 (completed, total)
     * @returns {Promise<void>}
     */
    app.loadScripts = async function (scripts, onProgress) {
        if (!Array.isArray(scripts) || scripts.length === 0) {
            return;
        }

        let completed = 0;

        for (const item of scripts) {
            const url = typeof item === 'string' ? item : item.url;
            const callback = typeof item === 'string' ? null : item.callback;

            await app.loadScript(url, callback);

            completed++;
            await safeCallback(onProgress, completed, scripts.length);
        }
    };

    /**
     * 并行批量加载脚本
     * @param {Array} scripts
     * @param {Function} [onProgress]
     * @returns {Promise<void>}
     */
    app.loadScriptsParallel = async function (scripts, onProgress) {
        if (!Array.isArray(scripts) || scripts.length === 0)
            return;

        let completed = 0;

        const tasks = scripts.map(function (item) {
            const url = typeof item === 'string' ? item : item.url;
            const callback = typeof item === 'string' ? null : item.callback;

            return app.loadScript(url, callback).then(function () {
                completed++;
                return safeCallback(onProgress, completed, scripts.length);
            });
        });

        await Promise.all(tasks);
    };

    app.loadStyles = async function (styles, onProgress) {
        if (!Array.isArray(styles) || styles.length === 0)
            return;

        let completed = 0;

        for (const style of styles) {
            await app.loadStyle(style);
            completed++;
            await safeCallback(onProgress, completed, styles.length);
        }
    };

    app.loadStylesParallel = function (styles, onProgress) {
        if (!Array.isArray(styles) || styles.length === 0)
            return Promise.resolve();

        let completed = 0;

        return Promise.all(
            styles.map(function (style) {
                return app.loadStyle(style).then(function () {
                    completed++;
                    return safeCallback(onProgress, completed, styles.length);
                });
            })
        );
    };

    /**
     * 解析错误响应
     * @param {jqXHR} xhr - Ajax 错误对象
     * @returns {Object}
     */
    app.parseErrorResponse = function (xhr) {
        const contentType = xhr.getResponseHeader('Content-Type') || '';

        if (contentType.includes('application/json')) {
            try {
                const json = JSON.parse(xhr.responseText);
                const msg = json.message || json.msg || 'Unknown error';
                return {message: decodeHtmlEntities(msg), raw: json};
            } catch (e) {
                return {message: 'Invalid JSON response', raw: null};
            }
        }

        if (contentType.includes('text/html')) {
            return {message: 'HTML error page received', raw: xhr.responseText};
        }

        return {message: xhr.statusText || 'Request failed', raw: null};
    };

    app.redirectToLogin = function () {
        // 防止重复跳转
        if (window._redirecting) return;
        window._redirecting = true;

        const fullUrl = window.location.href;
        sessionStorage.setItem('redirectUrl', fullUrl);

        // 如果已经在登录页，不重复跳转
        if (window.location.pathname.endsWith('/auth/login')) {
            window._redirecting = false;
            return;
        }

        // 使用 location.replace 避免历史记录问题
        window.location.replace(app.context_path + '/auth/login');
    };

    /**
     * 处理 Ajax 错误
     * @param {jqXHR} xhr - Ajax 错误对象
     * @param {string} url - 请求 URL
     * @param {jQuery} $container - 容器元素
     */
    app.handleLoadUrlError = function (xhr, url, $container) {
        // 登录失效
        if (xhr.status === 401) {
            if (app.redirectToLogin) {
                app.redirectToLogin();
            }
            return;
        }

        const errorInfo = app.parseErrorResponse(xhr);

        const errorHtml = '<h4 class="ajax-loading-error">' +
            '<i class="fas fa-warning color-red me-3"></i>' +
            'Error requesting: <span class="color-red">' + app.escapeHtml(url) + '</span>' +
            '<br>Status: ' + xhr.status +
            '</h4>' +
            '<div class="p-3">' + app.escapeHtml(errorInfo.message) + '</div>';

        $container.html(errorHtml);
    };

    /**
     * 加载 AJAX 页面
     * @param {string} url - 请求 URL
     * @param {jQuery} container - 容器元素
     * @returns {Promise}
     */
    app.loadURL = function (url, container) {
        const $container = $(container);
        const $jsPageContent = $('#js-page-content');
        const isMainContent = $container[0] === $jsPageContent[0];

        debugLog('info', 'Loading URL: ' + url);

        // 清理函数
        const cleanup = function () {
            if (!app_config.navAsAjax || !isMainContent) return;

            // 执行页面销毁钩子
            if (typeof window.pagedestroy === 'function') {
                try {
                    window.pagedestroy();
                    debugLog('success', 'pagedestroy() executed');
                } catch (err) {
                    console.warn('pagedestroy error:', err);
                    window.pagedestroy = undefined;
                }
            }

            // 清理日期选择器
            const $datepicker = $jsPageContent.find('.datepicker');
            if ($datepicker.length && $.fn.datepicker) {
                $datepicker.off();
                try {
                    $datepicker.datepicker('destroy');
                } catch (e) {
                    // 忽略 datepicker 销毁错误
                }
            }

            // 清理模态框
            $jsPageContent.find('.modal').each(function () {
                const $modal = $(this);
                if ($modal.data('bs.modal')) {
                    $modal.modal('hide');
                }
            });
            $('.modal-backdrop').remove();

            // 更新面包屑和滚动位置
            app.drawBreadCrumb();
            $('#ribbon').show();
            $('html, body').animate({scrollTop: 0}, 'fast');
        };

        // 清理并显示加载动画
        cleanup();
        $container.empty().html('<div class="ajax-loading-animation"><i class="fas fa-cog fa-spin"></i> Loading...</div>');

        // 发送异步请求
        return $.ajax({
            type: "GET",
            url: url,
            dataType: 'html',
            cache: true,
            timeout: 30000
        }).then(function (html) {
            // 🔥 检测是否返回了登录页面（多种方式检测）
            const isLoginPage = html.includes('loginForm') && html.includes('btnLogin');
            if (isLoginPage) {
                debugLog('warn', 'Received login page, redirecting...');
                app.redirectToLogin();
                return;
            }

            // 🔥 过滤掉可能导致重复加载的脚本
            const $html = $('<div>').html(html);
            // 移除核心 bundle 脚本（防止重复加载）
            $html.find('script[src*="app.bundle.js"]').remove();
            $html.find('script[src*="vendors.bundle.js"]').remove();

            // 移除包含 AppInit 或 MyApp 的内联脚本（这些已经在主页面加载过了）
            $html.find('script:not([src])').each(function () {
                const content = $(this).html() || $(this).text();
                if (content && (content.includes('AppInit') || content.includes('MyApp'))) {
                    $(this).remove();
                }
            });

            const filteredHtml = $html.html();


            $container.css('opacity', 0).html(html);
            return $container.animate({opacity: 1}, 300).promise();
        }).catch(function (xhr) {
            // 401 直接跳转登录
            if (xhr.status === 401) {
                app.redirectToLogin();
                return;
            }
            app.handleLoadUrlError(xhr, url, $container);
        });
    };

    /**
     * 其它各种设置
     */
    app.domReadyMisc = function () {
        app.hideSpinner();

        // 模态框可拖拽
        $(document).on("show.bs.modal", ".modal", function () {
            $(this).draggable({
                handle: ".modal-header",
                cursor: 'move'
            });
            $(this).css('overflow', '-moz-scrollbars-none').css('scrollbar-width', 'none');
        });

        // 设置日期格式
        if (app_config.appDateHook && app_config.appDateHook.length) {
            const formatted = app.getFormattedDate();
            app_config.appDateHook.text(formatted);
        }

        // 检查导航方向
        app.checkNavigationOrientation();
        app.initSlimScroll();

        // 激活导航检索
        const $dataListfilter = $('[data-listfilter]');
        if (typeof app.listFilter !== 'undefined' && $.isFunction(app.listFilter) && $dataListfilter.length) {
            const inputID = $dataListfilter.attr('id');
            const listFilter = $dataListfilter.attr("data-listfilter");
            app.listFilter(listFilter, '#' + inputID);
        }

        // 初始化工具提示
        app.initTooltip();
        app.initPopover();

        // 统一处理 data-action 事件
        app_config.root_.on('click touchend', '[data-action]', function (e) {
            const $this = $(this);
            const actiontype = $this.data('action');

            app.handleDataAction(actiontype, $this, e);

            if (getConfig('debugState', false)) {
                app.log('info', 'data-action clicked: ' + actiontype);
            }

            e.stopPropagation();
            e.preventDefault();
        });

        // Windows mobile 8 修复
        if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
            const msViewportStyle = document.createElement('style');
            msViewportStyle.appendChild(document.createTextNode('@-ms-viewport{width:auto!important}'));
            document.head.appendChild(msViewportStyle);
        }

        // 显示 APP 版本
        if (getConfig('debugState', false)) {
            app.log('success', 'Finished app.init() v' + app_config.VERSION);
        }
    };

    /**
     * 处理 data-action 事件
     * @param {string} actiontype - 动作类型
     * @param {jQuery} $element - 触发元素
     * @param {Event} event - 事件对象
     */
    app.handleDataAction = function (actiontype, $element, event) {
        // 或者打印 event 的关键属性
        if (event) {
            console.group('📌 Data Action Event');
            debugLog('debug', 'Action Type:', actiontype);
            debugLog('debug', 'Event Type:', event.type);
            debugLog('debug', 'Target:', event.target);
            debugLog('debug', 'Current Target:', event.currentTarget);
            debugLog('debug', 'Element ID:', $element.attr('id'));
            debugLog('debug', 'Element Classes:', $element.attr('class'));
            console.groupEnd();
        }

        switch (actiontype) {
            case 'toggle':
                app.handleToggleAction($element);
                break;
            case 'toggle-swap':
                app.handleToggleSwapAction($element);
                break;
            case 'app-reset':
                app.resetSettings();
                break;
            case 'factory-reset':
                app.factoryReset();
                break;
            case 'app-print':
                window.print();
                break;
            case 'app-loadscript':
                const loadurl = $element.attr('data-loadurl');
                const loadfunction = $element.attr('data-loadfunction');
                app.loadScript(loadurl, loadfunction).then(() => {
                });
                break;
            case 'app-fullscreen':
                app.toggleFullscreen();
                break;
            case 'app-scrollTop':
                window.scrollTo({top: 0, behavior: 'smooth'});
                break;
            case 'theme-update':
                app.updateTheme($element.attr('data-theme'));
                break;
            case 'lang':
                app.switchLanguage($element.attr('data-lang'));
                break;
            case 'playsound':
                const path = $element.attr('data-soundpath') || "media/sound/";
                const sound = $element.attr('data-soundfile');
                app.playSound(path, sound);
                break;
            default:
                if (actiontype && actiontype.startsWith('panel-')) {
                    app.handlePanelAction(actiontype, $element);
                }
                break;
        }
    };

    /**
     * 处理 toggle 动作
     * @param {jQuery} $element - 触发元素
     */
    app.handleToggleAction = function ($element) {
        const target = $element.attr('data-target') || app_config.root_;
        const dataClass = $element.attr('data-class');
        const inputFocus = $element.attr('data-focus');

        // 移除之前的背景图片类
        if (dataClass && dataClass.indexOf('mod-bg-') !== -1) {
            $(target).removeClass(function (index, css) {
                return (css.match(/(^|\s)mod-bg-\S+/g) || []).join(' ');
            });
        }

        $(target).toggleClass(dataClass);

        if ($element.hasClass('dropdown-item')) {
            $element.toggleClass('active');
        }

        if (inputFocus !== undefined) {
            setTimeout(function () {
                $('#' + inputFocus).focus();
            }, 200);
        }

        if (typeof classHolder != 'undefined' && classHolder != null) {
            app.checkNavigationOrientation();
            app.saveSettings();
        }
    };

    /**
     * 处理 toggle-swap 动作
     * @param {jQuery} $element - 触发元素
     */
    app.handleToggleSwapAction = function ($element) {
        const target = $element.attr('data-target');
        const dataClass = $element.attr('data-class');
        $(target).removeClass().addClass(dataClass);
        $element.siblings().removeClass('active');
        $element.next().addClass('active');
    };

    /**
     * 处理面板动作
     * @param {string} actiontype - 动作类型
     * @param {jQuery} $element - 触发元素
     */
    app.handlePanelAction = function (actiontype, $element) {
        const $panel = $element.closest('.panel');

        switch (actiontype) {
            case 'panel-collapse':
                $panel.children('.panel-container').collapse('toggle');
                $panel.on('shown.bs.collapse hidden.bs.collapse', function (e) {
                    $(this).toggleClass('panel-collapsed', e.type === 'hidden');
                });
                break;
            case 'panel-fullscreen':
                $panel.toggleClass('panel-fullscreen');
                $('body').toggleClass('panel-fullscreen');
                break;
            case 'panel-close':
                const panelTitle = $panel.find('.panel-hdr h2').text().trim();
                app.confirm(
                    "<i class='fas fa-times-circle text-danger me-2'></i> 确定移除此面板",
                    "<span><strong>警告:</strong> 此操作不可撤销!</span>",
                    function () {
                        $panel.fadeOut(500, function () {
                            $(this).remove();
                            debugLog('info', 'panel removed: ' + panelTitle);
                        });
                    }
                );
                break;
        }
    };

    /**
     * 切换全屏模式
     */
    app.toggleFullscreen = function () {
        const isFullscreen = !!(document.fullscreenElement || document.mozFullScreenElement ||
            document.webkitFullscreenElement || document.msFullscreenElement);

        if (!isFullscreen) {
            const el = document.documentElement;
            if (el.requestFullscreen) {
                el.requestFullscreen().then(() => {
                });
            } else if (el.msRequestFullscreen) {
                el.msRequestFullscreen();
            } else if (el.mozRequestFullScreen) {
                el.mozRequestFullScreen();
            } else if (el.webkitRequestFullscreen) {
                el.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            }
            debugLog('info', 'app fullscreen toggle active');
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen().then(() => {
                });
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            }
            debugLog('info', 'app fullscreen toggle inactive');
        }
    };

    /**
     * 更新主题
     * @param {string} themeUrl - 主题 URL
     */
    app.updateTheme = function (themeUrl) {
        if ($(app_config.mythemeAnchor).length) {
            $(app_config.mythemeAnchor).attr('href', themeUrl);
        } else {
            const mytheme = $("<link>", {
                id: app_config.mythemeAnchor.replace('#', ''),
                rel: "stylesheet",
                href: themeUrl
            });
            $('head').append(mytheme);
        }
        app.saveSettings();
    };

    /**
     * 切换语言
     * @param {string} lang - 语言代码
     */
    app.switchLanguage = function (lang) {
        if (!$.i18n) {
            app.loadScript("js/i18n/i18n.js", function () {
                $.i18n.init({
                    resGetPath: 'media/data/__lng__.json',
                    load: 'unspecific',
                    fallbackLng: false,
                    lng: lang
                }, function () {
                    $('[data-i18n]').i18n();
                });
            }).then(() => {
            });
        } else {
            i18n.setLng(lang, function () {
                $('[data-i18n]').i18n();
                $('[data-lang]').removeClass('active');
                $('[data-lang="' + lang + '"]').addClass('active');
            });
        }
    };

    /**
     * App Forms
     * @param {string} parentClass - 父容器类名
     * @param {string} focusClass - 聚焦类名
     */
    app.appForms = function (parentClass, focusClass) {
        $(parentClass).each(function () {
            const $input = $(this).find('.form-control');
            $input.on('focus', function () {
                $(this).parents(parentClass).addClass(focusClass);
            });
            $input.on('blur', function () {
                $(this).parents(parentClass).removeClass(focusClass);
            });
        });
    };

    /**
     * 导航作为 Ajax
     */
    app.navAsAjax = function () {
        if (!app_config.navAsAjax) return;

        // 页面加载时检查 URL
        if ($('nav#js-primary-nav').length) {
            app.checkURL();
        }

        // 导航点击事件
        $(document).on('click', 'nav#js-primary-nav a[href!="#"]', function (e) {
            e.preventDefault();
            const $this = $(e.currentTarget);

            if (!$this.parent().hasClass("active") && !$this.attr('target')) {
                const hashValue = $this.attr('href');

                // 🔥 前置检查：如果当前页面已经显示登录页，直接跳转
                const $pageContent = $('#js-page-content');
                if ($pageContent.find('form#loginForm').length > 0) {
                    // 如果当前页面已经是登录页，直接跳转
                    window.location.href = app.context_path + '/auth/login';
                    return;
                }

                if (app_config.root_.hasClass('mobile-view-activated')) {
                    app_config.root_.removeClass('mobile-nav-on');
                    setTimeout(function () {
                        const baseUrl = window.location.href.replace(window.location.search, '').replace(window.location.hash, '');
                        window.location.href = baseUrl + '#' + hashValue;
                    }, 150);
                } else {
                    const baseUrl = window.location.href.replace(window.location.search, '').replace(window.location.hash, '');
                    window.location.href = baseUrl + '#' + hashValue;
                }
            }
        });

        // 新窗口打开
        $(document).on('click', 'nav a[target="_blank"]', function (e) {
            e.preventDefault();
            window.open($(e.currentTarget).attr('href'));
        });

        // 同窗口打开
        $(document).on('click', 'nav a[target="_top"]', function (e) {
            e.preventDefault();
            window.location = $(e.currentTarget).attr('href');
        });

        // 忽略空链接
        $(document).on('click', 'nav a[href="#"]', function (e) {
            e.preventDefault();
        });

        // Hash 变化监听
        $(window).on('hashchange', function () {
            app.checkURL();
        });
    };

    /**
     * 初始化滑动导航（手机适配）
     * 支持右滑显示导航菜单，左滑关闭导航菜单
     */
    app.initSwipeNavigation = function () {
        // 检查是否为移动设备或窄屏幕（宽度小于 992px）
        let isMobileDevice = false;

        // 方法 1: 检查 app_config.isMobile
        if (app_config && app_config.isMobile) {
            isMobileDevice = true;
        }

        // 方法 2: 检查屏幕宽度（更可靠）
        if (window.innerWidth < 992) {
            isMobileDevice = true;
        }

        // 方法 3: 检查是否有触摸支持
        if ('ontouchstart' in window || navigator.maxTouchPoints > 0) {
            isMobileDevice = true;
        }

        if (isMobileDevice && $.fn.swipeNavigation) {
            // 初始化滑动导航，设置触摸区域为整个页面
            $(document).swipeNavigation({
                threshold: 80,           // 滑动 80px 触发
                maxTime: 500,            // 500ms 内的滑动
                enableEdgeOnly: false    // 整个屏幕都可以滑动（设为 true 则仅左边缘有效）
            });

            if (app_config.debugState) {
                console.log('%c✅ Swipe navigation initialized', 'color: #198754; font-weight: bold;');
            }
        }
    };

    /**
     * 保存设置
     */
    app.saveSettings = function () {
        if (typeof saveSettings !== 'undefined' && $.isFunction(saveSettings) && getConfig('storeLocally', true)) {
            app.accessIndicator();
            saveSettings();
            debugLog('success', 'Theme settings saved');
        } else {
            debugLog('error', 'saveSettings function does not exist');
        }
    };

    /**
     * 自定义 Confirm 对话框
     * @param {string} title - 标题
     * @param {string} message - 消息内容
     * @param {Function} func - 确认后执行的函数
     */
    app.confirm = function (title, message, func) {
        app.playSound(app.context_path + '/assets/media/sound', 'voice_on');

        const confirmTitle = title || "<i class='bi bi-exclamation-triangle text-warning mx-2'></i> 确认操作";
        const confirmMessage = message || "<span><strong>警告:</strong> 操作不可撤销!</span>";
        const callback = func || function () {
        };

        Swal.fire({
            title: confirmTitle,
            html: confirmMessage,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-secondary"
            },
            allowOutsideClick: false,
            allowEscapeKey: true
        }).then(function (result) {
            if (result.isConfirmed) {
                callback();
            }
        });
    };

    /**
     * 重置设置
     */
    app.resetSettings = function () {
        app_config.root_.removeClass(function (index, className) {
            return (className.match(/(^|\s)(nav-|header-|mod-|display-)\S+/g) || []).join(' ');
        });

        $(app_config.mythemeAnchor).attr('href', "");
        app.checkNavigationOrientation();
        app.saveSettings();

        debugLog('success', 'App reset successful');
    };

    /**
     * 恢复出厂设置
     */
    app.factoryReset = function () {
        app.playSound(app.context_path + '/assets/media/sound', 'messagebox');
        $('.js-modal-settings').modal('hide');

        const title = "<i class='fas fa-exclamation-triangle text-warning me-2'></i> 确认重置所有布局设置";
        const message = "<span><strong>警告:</strong>此操作不可逆。所有的布局设置将会被重置。</span>";

        app.confirm(title, message, function () {
            localStorage.clear();
            app.resetSettings();
            location.reload();
        });

        debugLog('success', 'Factory reset initiated');
    };

    /**
     * 访问指示器
     */
    app.accessIndicator = function () {
        app_config.root_.addClass('saving').delay(600).queue(function () {
            $(this).removeClass('saving').dequeue();
            return true;
        });
    };

    /**
     * 推送设置
     * @param {string} DB_string - 设置字符串
     * @param {boolean} saveToLocal - 是否保存到本地
     * @returns {string}
     */
    app.pushSettings = function (DB_string, saveToLocal) {
        if (saveToLocal !== false) {
            localStorage.setItem("themeSettings", "");
        }

        app_config.root_.addClass(DB_string);
        app.checkNavigationOrientation();

        if (saveToLocal !== false) {
            app.saveSettings();
        }

        return DB_string;
    };

    /**
     * 获取设置
     * @returns {string}
     */
    app.getSettings = function () {
        return app_config.root_.attr('class').split(/[^\w-]+/).filter(function (item) {
            return /^(nav|header|mod|display)-/i.test(item);
        }).join(' ');
    };

    /**
     * 播放声音
     * @param {string} path - 路径
     * @param {string} sound - 声音文件名
     */
    app.playSound = function (path, sound) {
        const audioElement = new Audio();
        const extension = navigator.userAgent.match('Firefox/') ? 'ogg' : 'mp3';
        audioElement.src = path + '/' + sound + '.' + extension;
        audioElement.play().catch(function (error) {
            console.error("Audio play error:", error);
        });
    };

    /**
     * 窗口滚动事件
     */
    app.windowScrollEvents = function () {
        if (app_config.root_.is('.nav-function-hidden.header-function-fixed:not(.nav-function-top)') &&
            app_config.thisDevice === 'desktop') {
            app_config.root_logo.css({'top': $(window).scrollTop()});
        } else if (app_config.root_.is('.header-function-fixed:not(.nav-function-top):not(.nav-function-hidden)') &&
            app_config.thisDevice === 'desktop') {
            app_config.root_logo.attr("style", "");
        }
    };

    /**
     * 检查导航方向
     */
    app.checkNavigationOrientation = function () {
        // 处理 slimScroll
        const isFixedNav = app_config.root_.hasClass('nav-function-fixed') &&
            !app_config.root_.is('.nav-function-top, .nav-function-minify, .mod-main-boxed') &&
            app_config.thisDevice === 'desktop';

        if (isFixedNav && typeof $.fn.slimScroll !== 'undefined') {
            if (app_config.navAnchor.parent().hasClass('slimScrollDiv')) {
                app_config.navAnchor.slimScroll({destroy: true});
                app_config.navAnchor.attr('style', '');

                // 清除事件监听器
                const events = jQuery._data(app_config.navAnchor[0], "events");
                if (events) jQuery._removeData(app_config.navAnchor[0], "events");

                debugLog('warn', 'slimScroll destroyed');
            }

            app_config.navAnchor.slimScroll({
                height: '100%',
                color: '#fff',
                size: '4px',
                distance: '4px',
                railOpacity: 0.4,
                wheelStep: 10
            });

            if (document.getElementById(app_config.navHorizontalWrapperId)) {
                app_config.navHooks.menuSlider('destroy');
                debugLog('success', 'top controls destroyed');
            }

            debugLog('success', 'slimScroll created');
        } else if (app_config.navAnchor.parent().hasClass('slimScrollDiv') &&
            app_config.thisDevice === 'desktop' && typeof $.fn.slimScroll !== 'undefined') {
            app_config.navAnchor.slimScroll({destroy: true});
            app_config.navAnchor.attr('style', '');

            const events = jQuery._data(app_config.navAnchor[0], "events");
            if (events) jQuery._removeData(app_config.navAnchor[0], "events");

            debugLog('warn', 'slimScroll destroyed');
        }

        // 处理水平导航
        const $jsNavMenuWrapper = $("#js-nav-menu-wrapper");
        const hasHorizontalWrapper = $jsNavMenuWrapper.length === 0;
        const isNavFunctionTop = app_config.root_.hasClass('nav-function-top');
        const isMobileView = app_config.root_.hasClass('mobile-view-activated');

        if ($.fn.menuSlider && isNavFunctionTop && hasHorizontalWrapper && !isMobileView) {
            app_config.navHooks.menuSlider({
                element: app_config.navHooks,
                wrapperId: app_config.navHorizontalWrapperId
            });
            debugLog('success', 'top controls created');
        } else if (isNavFunctionTop && $jsNavMenuWrapper.length && isMobileView) {
            app_config.navHooks.menuSlider('destroy');
            debugLog('warn', 'top controls destroyed');
        } else if (!isNavFunctionTop && $jsNavMenuWrapper.length) {
            app_config.navHooks.menuSlider('destroy');
            debugLog('warn', 'top controls destroyed');
        }
    };

    /**
     * 销毁导航
     * @param {string} id - 导航 ID
     */
    app.destroyNavigation = function (id) {
        if ($.fn.navigation) {
            $(id).navigationDestroy();
        } else {
            debugLog('warn', 'navigation plugin missing');
        }
    };

    /**
     * 切换可见性
     * @param {string} id - 元素 ID
     */
    app.toggleVisibility = function (id) {
        const e = document.getElementById(id);
        if (e) {
            e.style.display = e.style.display === 'block' ? 'none' : 'block';
        }
    };

    /**
     * 切换按钮加载状态
     * @param {string|HTMLElement|jQuery} btn_el - 按钮元素
     * @param {boolean} isLoading - 是否加载中
     */
    app.toggleSpinner = function (btn_el, isLoading) {
        const $btn = $(btn_el);
        const loading = isLoading !== false;

        if ($btn.length === 0) {
            debugLog('warn', 'Button not found: ' + btn_el);
            return;
        }

        if (loading) {
            $btn.prop('disabled', true);
            if (!$btn.find('.spinner-border').length)
                $btn.prepend('<i class="spinner-border spinner-border-sm me-2"></i>');
        } else {
            $btn.prop('disabled', false).find('.spinner-border').remove();
        }
    };

    /**
     * 页面设置（Ajax 加载时调用）
     */
    app.pageSetUp = function () {
        app.log('info', 'entering app.pageSetUp();');

        // 表单样式设置
        $('#js-page-content .input-group').each(function () {
            const $input = $(this).find('.form-control');
            $input.off('focus').on('focus', function () {
                $(this).parents('.input-group').addClass('has-length');
            });
            $input.off('blur').on('blur', function () {
                $(this).parents('.input-group').removeClass('has-length');
            });
        });

        // 初始化工具提示
        app.initTooltip();
        app.initPopover();
        app.initDatepicker();

        // 初始化 select2
        if (typeof $.fn.select2 !== 'undefined') {
            const $select2 = $('#js-page-content .select2');
            if ($select2.length) {
                $select2.select2();
            }
        } else {
            debugLog('error', '.fn.select2 is not loaded');
        }

        // 绑定页面内 data-action 事件
        app.bindPageActions();
    };

    /**
     * 绑定页面内的动作事件
     */
    app.bindPageActions = function () {
        $('#js-page-content [data-action]').off('click').on('click', function (e) {
            const actiontype = $(this).data('action');
            app.handlePanelAction(actiontype, $(this));

            if (getConfig('debugState', false)) {
                app.log('info', 'data-action clicked: ' + actiontype);
            }

            e.stopPropagation();
            e.preventDefault();
        });

        $('#js-page-content [data-dblclick-action]').off('dblclick').on('dblclick', function (e) {
            const actiontype = $(this).data('dblclick-action');

            if (actiontype === 'panel-collapse' || actiontype === 'panel-close') {
                app.handlePanelAction(actiontype, $(this));
            } else if (actiontype === 'playsound') {
                const path = $(this).attr('data-soundpath') || "media/sound/";
                const sound = $(this).attr('data-soundfile');
                app.playSound(path, sound);
            }

            if (getConfig('debugState', false)) {
                app.log('info', 'data-dblclick-action clicked: ' + actiontype);
            }

            e.stopPropagation();
            e.preventDefault();
        });
    };

    /**
     * 初始化 SlimScroll
     */
    app.initSlimScroll = function () {
        if (typeof $.fn.slimScroll !== 'undefined' && app_config.thisDevice === 'desktop') {
            $('.custom-scroll:not(.disable-slimscroll) >:first-child').each(function () {
                const $this = $(this);
                $this.slimscroll({
                    height: $this.data('scrollHeight') || '100%',
                    size: $this.data('scrollSize') || '4px',
                    position: $this.data('scrollPosition') || 'right',
                    color: $this.data('scrollColor') || 'rgba(0,0,0,0.6)',
                    alwaysVisible: $this.data('scrollAlwaysVisible') || false,
                    distance: $this.data('scrollDistance') || '4px',
                    railVisible: $this.data('scrollRailVisible') || false,
                    railColor: $this.data('scrollRailColor') || '#fafafa',
                    allowPageScroll: false,
                    disableFadeOut: false
                });
            });

            debugLog('success', 'SlimScroll plugin active');
        } else {
            console.log("WARN! $.fn.slimScroll not loaded or user is on desktop");
            app_config.root_.addClass("no-slimscroll");
        }
    };

    /**
     * 初始化 flatpickr 日期选择器
     */
    app.initDatepicker = function () {
        if (typeof flatpickr === 'undefined') {
            debugLog('error', 'flatpickr is not loaded');
            return;
        }

        const flatOptions = {
            allowInput: true,
            clickOpens: true,
            locale: 'zh'
        };

        const initPicker = function (selector, options) {
            document.querySelectorAll('#js-page-content [data-toggle="' + selector + '"]').forEach(function (element) {
                flatpickr(element, options);
            });
        };

        initPicker('datepicker', {...flatOptions, dateFormat: 'Y-m-d'});
        initPicker('datetimepicker', {...flatOptions, enableTime: true, dateFormat: 'Y-m-d H:i'});
        initPicker('daterange', {...flatOptions, mode: 'range', dateFormat: 'Y-m-d'});
        initPicker('datetimerange', {...flatOptions, mode: 'range', enableTime: true, dateFormat: 'Y-m-d H:i'});

        debugLog('success', 'flatpickr loaded');
    };

    /**
     * 初始化 Bootstrap Popover
     */
    app.initPopover = function () {
        if (typeof bootstrap !== 'undefined' && typeof bootstrap.Popover !== 'undefined') {
            const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
            Array.from(popoverTriggerList).forEach(function (popoverTriggerEl) {
                new bootstrap.Popover(popoverTriggerEl);
            });
            debugLog('success', 'bootstrap.Popover enabled');
        } else {
            debugLog('error', 'bootstrap.Popover not loaded');
        }
    };

    /**
     * 初始化 Bootstrap Tooltip
     */
    app.initTooltip = function () {
        if (typeof bootstrap !== 'undefined' && typeof bootstrap.Tooltip !== 'undefined') {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
            Array.from(tooltipTriggerList).forEach(function (tooltipTriggerEl) {
                new bootstrap.Tooltip(tooltipTriggerEl);
            });
            debugLog('success', 'bootstrap.Tooltip enabled');
        } else {
            debugLog('error', 'bootstrap.Tooltip not loaded');
        }
    };

    /**
     * 模态框页面设置
     * @param {string} modalBody - 模态框内容选择器
     */
    app.modalPageSetUp = function (modalBody = '#editModalBody') {
        const $modalBody = $(modalBody || '#editModalBody');
        const $select2 = $modalBody.find('.select2');

        if (typeof $.fn.select2 !== 'undefined' && $select2.length) {
            $select2.select2({dropdownParent: $modalBody});
        }

        app.initTooltip();
        app.initPopover();
        app.initDatepicker();
    };

    /**
     * 检查并加载 URL
     */
    app.checkURL = function () {
        let url = '';

        try {
            const fullHash = window.location.hash;
            if (fullHash && fullHash.startsWith('#')) {
                url = fullHash.slice(1);
                const queryIndex = url.indexOf('?');
                if (queryIndex !== -1) {
                    url = url.substring(0, queryIndex);
                }
            }
        } catch (e) {
            console.warn("Failed to parse URL hash:", e);
        }

        if (url) {
            app.activeNav(url);
            const $container = $('#js-page-content');
            app.loadURL(url, $container).then(() => {
            });
        } else {
            const $firstNav = $('nav#js-primary-nav > ul > li:first-child > a[href!="#"]');
            if ($firstNav.length) {
                window.location.hash = $firstNav.attr('href');
            }
        }
    };

    /**
     * 获取 Cookie
     * @param {string} name - Cookie 名称
     * @returns {string|null}
     */
    app.getCookie = function (name) {
        let cookieValue = null;
        if (document.cookie && document.cookie !== '') {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.substring(0, name.length + 1) === (name + '=')) {
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                    break;
                }
            }
        }
        return cookieValue;
    };

    /**
     * 加载页面
     * @param {string} url - 页面 URL
     */
    app.loadPage = function (url) {
        if (url && url !== "undefined" && url.trim().length > 0) {
            const baseUrl = location.href.split('#')[0];
            location.href = baseUrl + '#' + url;

            app.activeNav(url);

            const $container = $('#js-page-content');
            app.loadURL(url + location.search, $container).then(() => {
            });
        } else {
            const $firstNav = $('nav#js-primary-nav > ul > li:first-child > a[href!="#"]');
            if ($firstNav.attr('href')) {
                window.location.hash = $firstNav.attr('href');
            }
        }
    };

    /**
     * 加载应用列表项页面
     * @param {string} url - 页面 URL
     */
    app.loadAppListItemPage = function (url) {
        app.loadPage(url);
        $('.header-shortcuts').modal('hide');
    };

    /**
     * 在新窗口打开页面
     * @param {string} url - 页面 URL
     */
    app.openPage = function (url) {
        if (url && url !== "undefined" && url.trim().length > 0) {
            const href = location.href.split('#')[0] + '#' + url + location.search;
            window.open(href);
        }
    };

    /**
     * 获取格式化的日期字符串
     * @returns {string}
     */
    app.getFormattedDate = function () {
        const months = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
        const days = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        const now = new Date();

        return now.getFullYear() + '年 ' + months[now.getMonth()] + ' ' + now.getDate() + '日 ' + days[now.getDay()];
    };

    /**
     * 绘制面包屑导航
     */
    app.drawBreadCrumb = function () {
        const $activeLinks = $("nav li.active > a");
        const $breadcrumb = $('#ribbon ol.breadcrumb');

        $breadcrumb.empty();
        $breadcrumb.append('<li class="breadcrumb-item"><a href="' + app.context_path + '/admin">~<i class="fas fa-home"></i>~ 首页</a></li>');

        $activeLinks.each(function () {
            $breadcrumb.append("<li class='breadcrumb-item'>" + $(this).text() + "</li>");
            document.title = $breadcrumb.find("li:last-child").text();
        });

        const formatted = app.getFormattedDate();
        $breadcrumb.append('<li class="position-absolute pos-top pos-right d-none d-sm-block"><span class="js-get-date">' + formatted + '</span></li>');
    };

    /**
     * 激活导航项
     * @param {string} url - URL
     */
    app.activeNav = function (url) {
        // 去掉查询参数
        url = url.split('?')[0].trim();

        $('nav#js-primary-nav li.active').removeClass("active");

        const $targetLink = $('nav#js-primary-nav li:has(a[href="' + url + '"])');
        $targetLink.addClass("active");
        $targetLink.parents("li.active").addClass("open");

        const title = $('nav#js-primary-nav a[href="' + url + '"]').attr('title') || "";
        if (title) {
            document.title = title;
        }

        debugLog("info", "Page title: " + document.title);
    };

    /**
     * 显示加载遮罩
     * @param {Object} options - 配置选项
     */
    app.showSpinner = function (options) {
        options = options || {};
        const $spinner = $(options.spinner || '#spinner_overlay');
        const message = options.message || 'Loading...';
        const timeout = options.timeout;

        if ($spinner.length)
            $spinner.fadeIn('fast');

        if (message) {
            $spinner.find('#spinner_overlay_message').html(message);
        }

        debugLog('info', 'show spinner');

        if (typeof timeout === 'number' && timeout > 0) {
            setTimeout(function () {
                if ($spinner.length) {
                    $spinner.fadeOut('fast');
                }
                debugLog('info', 'spinner auto-hidden after timeout: ' + timeout + 'ms');
            }, timeout);
        }
    };

    /**
     * 隐藏加载遮罩
     * @param {jQuery} [$spinner] - 遮罩元素
     */
    app.hideSpinner = function ($spinner) {
        const $target = $spinner || $('#spinner_overlay');
        if ($target.length) {
            $target.fadeOut('fast');
        }
        debugLog('info', 'hide spinner');
    };

    /**
     * 显示成功对话框
     * @param {string} message - 消息
     * @param {number} [timeout=0] - 自动关闭时间（毫秒）
     * @param {boolean} [closeable=true] - 是否可关闭
     */
    app.showSuccessDialog = function (message, timeout, closeable) {
        const swalConfig = {
            html: message,
            icon: "success",
            draggable: true,
            confirmButtonText: "OK",
            customClass: {
                popup: "bg-light",
                title: "text-success",
                confirmButton: "btn btn-success"
            },
            allowOutsideClick: closeable !== false,
            allowEscapeKey: closeable !== false
        };

        if (timeout > 0) {
            swalConfig.timer = timeout;
            swalConfig.timerProgressBar = true;
        }

        Swal.fire(swalConfig);
    };

    /**
     * 显示成功消息
     * @param {string} message - 消息
     * @param {jQuery} [$element] - 容器元素
     */
    app.showSuccessMsg = function (message, $element) {
        const $container = app.getErrorMsgDivContainer($element);
        if ($container && $container.length) {
            $container.removeClass("text-danger d-none").addClass("text-success").html(message || '');

            const $result = app.$result || (app.$result = $('#result'));
            if ($result.length) $result.empty();
        } else {
            app.showSuccessDialog(message);
        }
    };

    /**
     * 显示错误对话框
     * @param {string} message - 消息
     * @param {number} [timeout] - 自动关闭时间
     */
    app.showErrorDialog = function (message, timeout) {
        app.playSound(app.context_path + '/assets/media/sound', 'voice_alert');

        const swalConfig = {
            html: message,
            icon: "error",
            draggable: true,
            confirmButtonText: "OK",
            customClass: {
                popup: "bg-light",
                title: "text-danger",
                confirmButton: "btn btn-danger"
            },
            allowOutsideClick: false,
            allowEscapeKey: false
        };

        if (timeout > 0) {
            swalConfig.timer = timeout;
            swalConfig.timerProgressBar = true;
        }

        Swal.fire(swalConfig);
    };

    /**
     * 获取错误消息容器
     * @param {jQuery} [$element] - 指定元素
     * @returns {jQuery|null}
     */
    app.getErrorMsgDivContainer = function ($element) {
        if ($element && $element.length) return $element;
        const $byId = $('#errorMsgDiv');
        if ($byId.length) return $byId;
        const $byClass = $('.errorMsgDiv');
        if ($byClass.length) return $byClass.eq(0);
        return null;
    };

    /**
     * 显示错误消息
     * @param {string} message - 消息
     * @param {jQuery} [$element] - 容器元素
     */
    app.showErrorMsg = function (message, $element) {
        const $container = app.getErrorMsgDivContainer($element);
        if ($container && $container.length) {
            $container.removeClass("text-success d-none").addClass("text-danger").html(message || '');

            const $result = app.$result || (app.$result = $('#result'));
            if ($result.length) $result.empty();
        } else {
            app.showErrorDialog(message);
        }
    };

    /**
     * 隐藏错误消息
     * @param {jQuery} [$element] - 容器元素
     */
    app.hideErrorMsg = function ($element) {
        const $container = app.getErrorMsgDivContainer($element);
        if ($container && $container.length) {
            $container.addClass('d-none').removeClass('text-danger text-success').empty();
        }
    };

    /**
     * 格式化日期
     * @param {Date} date - 日期对象
     * @param {string} [format='YYYY-MM-DD'] - 格式
     * @returns {string}
     */
    app.formatDate = function (date, format) {
        const fmt = format || 'YYYY-MM-DD';
        const pad = function (n) {
            return n.toString().padStart(2, '0');
        };

        const year = date.getFullYear();
        const month = pad(date.getMonth() + 1);
        const day = pad(date.getDate());
        const hours = pad(date.getHours());
        const minutes = pad(date.getMinutes());
        const seconds = pad(date.getSeconds());

        return fmt
            .replace('YYYY', year + '')
            .replace('MM', month)
            .replace('DD', day)
            .replace('HH', hours)
            .replace('mm', minutes)
            .replace('ss', seconds);
    };

    /**
     * 格式化数字显示单位
     * @param num - 数字
     * @param {number} decimal - 小数位数
     * @param {number} maxNumLen - 最大数字长度
     * @returns {string}
     */
    app.formatNumUnit = function (num, decimal, maxNumLen) {
        if (num === "-" || num === "" || num === undefined) {
            return num;
        }

        let max = maxNumLen !== undefined ? maxNumLen : 5;
        max = max < 5 ? 5 : max;
        let dec = decimal !== undefined ? decimal : 0;
        dec = dec < 0 ? 0 : dec;

        // 自动计算小数位数
        if (decimal === undefined) {
            if (Math.abs(num) < 0.01) {
                const absn = Math.abs(num);
                let sub = 2;
                for (let i = 1; i < 10; i++) {
                    if (absn * Math.pow(10, i) > 1) {
                        sub = i + 1;
                        break;
                    }
                }
                dec = sub;
                max = sub + 2;
            } else {
                const parts = (num + "").split(".");
                if (parts[1] && parts[1].length > 4) {
                    dec = 4;
                } else if (parts[1]) {
                    dec = parts[1].length;
                }
            }
        }

        try {
            num = parseFloat(num);
        } catch (error) {
            return num;
        }

        const sign = Math.sign(num);
        let temp = Math.abs(num);
        let suffix = "";

        if (temp >= 10000 && temp < 100000000) {
            suffix = "万";
            temp = temp / 10000;
        } else if (temp >= 100000000) {
            suffix = "亿";
            temp = temp / 100000000;
        } else if (temp >= 1000000000000) {
            suffix = "万亿";
            temp = temp / 1000000000000;
        }

        if ((temp + "").indexOf(".") === max - 1) {
            max += 1;
        }

        let result = temp.toFixed(dec).substring(0, max);

        if (sign < 0) {
            result = "-" + result;
        }
        if (result.indexOf(".") === result.length - 1) {
            result = result.substring(0, result.length - 1);
        }

        return result + suffix;
    };

    return app;

})(window.MyApp = window.MyApp || {}, app_config);


const AppInit = window.AppInit; // 局部引用



/*!
 * app.ajax.js
 * Ajax Core Module
 * 兼容传统 jQuery Admin 后台体系
 */
(function (app, window, document, $) {
    'use strict';

    if (!$) throw new Error('jQuery is required');

    // ✅ 防止重复初始化
    if (app._ajax_initialized) return app;

    app._ajax_initialized = true;

    // ajax defaults
    // =========================================================

    app.defaults = $.extend(true, {ajax: {}}, app.defaults || {});

    app.defaults.ajax = $.extend(true, {
        method: 'GET',
        dataType: 'json',
        async: true,
        cache: false,
        processData: true,
        timeout: 30000,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
        headers: {},
        showSpinner: false,
        showError: true,
        showBusinessError: true,
        silent: false,
        repeatSubmit: false,
        loadingText: '处理中...',
        triggerButton: null,
        beforeSend: null,
        complete: null,
        success: null,
        error: null
    }, app.defaults.ajax || {});

    // request pool
    // =========================================================

    // 增加 request cache（非常重要） 防止：重复点击提交
    app._ajaxPool = app._ajaxPool || {};
    app._ajaxCount = app._ajaxCount || 0;

    // util
    // =========================================================

    app.generateRequestId = function () {
        return 'REQ_' +
            Date.now() +
            '_' +
            Math.random().toString(36).substring(2, 10);
    };

    app.toggleButtonLoading = function ($btn, loading, loadingText) {
        if (!$btn || !$btn.length) {
            return;
        }
        if (loading) {
            if (!$btn.data('origin-html')) {
                $btn.data('origin-html', $btn.html());
            }
            $btn
                .prop('disabled', true)
                .addClass('disabled')
                .html(
                    '<i class="fas fa-spinner fa-spin me-1"></i>' +
                    (loadingText || '处理中...')
                );
        } else {
            $btn
                .prop('disabled', false)
                .removeClass('disabled');
            const originHtml = $btn.data('origin-html');
            if (originHtml) {
                $btn.html(originHtml);
            }
        }
    };

    app.parseAjaxError = function (xhr) {
        let msg = '系统异常';
        try {
            const contentType = xhr.getResponseHeader('Content-Type');
            if (contentType && contentType.indexOf('application/json') !== -1) {
                const json = JSON.parse(xhr.responseText);
                msg = json.message ||
                    json.msg ||
                    json.error ||
                    msg;
            } else if (xhr.responseText) {
                msg = xhr.responseText;
            }
        } catch (e) {
            app.logger?.error?.(e);
        }
        return msg;
    };

    // business success
    // =========================================================
    app.isSuccess = function (resp) {
        if (!resp) return false;

        return !!(
            resp.success === true ||
            resp.code === 200 ||
            resp.code === '200'
        );
    };

    app.isLoginTimeout = function (resp) {
        if (!resp) return false;

        return !!(resp && (
                resp.code === 401 ||
                resp.code === 403 ||
                resp.login === false
            )
        );
    };

    // ajax error
    // =========================================================
    app.handleAjaxError = function (xhr, textStatus, errorThrown, options = {}) {
        let msg;
        if (xhr.status === 0) {
            msg = '网络连接失败';
        } else if (textStatus === 'timeout') {
            msg = '请求超时';
        } else {
            switch (xhr.status) {
                case 400:
                    msg = '请求参数错误';
                    break;
                case 401:
                    if (app.redirectToLogin) {
                        app.redirectToLogin();
                        // 重要：返回一个特殊标记，阻止后续处理
                        return 'LOGIN_REDIRECT';
                    }
                    msg = '登录已失效';
                    break;
                case 403:
                    msg = '无权限访问';
                    break;
                case 404:
                    msg = '请求不存在';
                    break;
                case 500:
                    msg = app.parseAjaxError(xhr);
                    if (!msg || msg === '系统异常') {
                        msg = '服务器内部错误';
                    }
                    break;
                default:
                    msg = app.parseAjaxError(xhr);
            }
        }
        if (options.showError !== false && options.silent !== true) {
            if (app.showErrorDialog) {
                app.showErrorDialog(msg);
            } else {
                alert(msg);
            }
        }

        if (app.logger?.error) {
            app.logger.error('[AJAX ERROR]', {
                status: xhr.status,
                textStatus,
                errorThrown,
                response: xhr.responseText
            });
        }

        if ($.isFunction(options.error)) {
            options.error(
                xhr,
                'http',
                msg,
                null
            );
        }

        return msg;
    };

    // ajax core
    // =========================================================
    app.ajax = function (options = {}) {
        const opts = $.extend(
            true,
            {},
            app.defaults.ajax,
            options
        );

        if (!opts.url) {
            const errMsg = 'ajax url is undefined';
            if (app.showErrorDialog) {
                app.showErrorDialog(errMsg);
            }
            return $.Deferred().reject(errMsg).promise();
        }

        const requestId = app.generateRequestId();
        const $btn = opts.triggerButton
            ? $(opts.triggerButton)
            : null;

        // duplicate request check
        const requestKey = opts.method + ':' + opts.url + ':' + JSON.stringify(opts.data || {});
        if (opts.repeatSubmit !== true && app._ajaxPool[requestKey]) {
            if (app.logger?.warn) {
                app.logger.warn('[AJAX REPEAT BLOCKED]', opts.url);
            }

            return app._ajaxPool[requestKey];
        }

        // spinner
        if (opts.showSpinner === true && app.showSpinner) {
            app._ajaxCount++;
            if (app._ajaxCount === 1) {
                app.showSpinner({});
            }
        }

        // button loading
        app.toggleButtonLoading($btn, true, opts.loadingText);

        // debug log
        if (app.logger?.info) {
            app.logger.info('[AJAX REQUEST]', {
                requestId,
                url: opts.url,
                method: opts.method,
                data: opts.data
            });
        }

        // ajax config
        const ajaxOptions = {
            url: opts.url,
            type: opts.method,
            data: opts.data,
            dataType: opts.dataType,
            async: opts.async,
            cache: opts.cache,
            processData: opts.processData,
            timeout: opts.timeout,
            contentType: opts.contentType,
            headers: opts.headers,
            beforeSend(xhr, settings) {
                xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

                xhr.setRequestHeader('X-App-Request-Id', requestId);

                if ($.isFunction(opts.beforeSend)) {
                    return opts.beforeSend(xhr, settings);
                }
            },
            complete(jqXHR, textStatus) {
                // spinner
                if (opts.showSpinner === true && app.hideSpinner) {
                    app._ajaxCount--;
                    if (app._ajaxCount <= 0) {
                        app._ajaxCount = 0;
                        app.hideSpinner();
                    }
                }

                // button
                app.toggleButtonLoading($btn, false);
                // remove request pool
                delete app._ajaxPool[requestKey];

                // user complete
                if ($.isFunction(opts.complete)) {
                    opts.complete(jqXHR, textStatus);
                }
            }
        };

        // create xhr
        const xhr = $.ajax(ajaxOptions)
            .done(function (resp, textStatus, jqXHR) {
                if (app.logger?.info) {
                    app.logger.info('[AJAX RESPONSE]', {
                        requestId,
                        url: opts.url,
                        response: resp
                    });
                }

                // html/text 直接 success
                if (opts.dataType === 'html' || opts.dataType === 'text') {
                    if ($.isFunction(opts.success)) {
                        opts.success(
                            resp,
                            textStatus,
                            jqXHR
                        );
                    }
                    return;
                }

                // login timeout
                if (app.isLoginTimeout(resp)) {
                    if (app.redirectToLogin) {
                        app.redirectToLogin();
                    }
                    return;
                }

                // business error
                if (!app.isSuccess(resp)) {
                    const msg =
                        resp.message ||
                        resp.msg ||
                        '操作失败';
                    if (opts.showBusinessError !== false && opts.silent !== true) {
                        if (app.showErrorMsg) {
                            app.showErrorMsg(msg);
                        }
                    }

                    if ($.isFunction(opts.error)) {
                        opts.error(
                            jqXHR,
                            'business',
                            msg,
                            resp
                        );
                    }

                    return;
                }

                // success callback
                if ($.isFunction(opts.success)) {
                    opts.success(
                        resp,
                        textStatus,
                        jqXHR
                    );
                }
            })

            .fail(function (xhr, textStatus, errorThrown) {
                if (textStatus === 'abort')
                    return;
                try {
                    const result = app.handleAjaxError(xhr, textStatus, errorThrown, opts);
                } catch (e) {
                    app.logger?.error?.(e);
                }
            });

        // save request
        app._ajaxPool[requestKey] = xhr;

        return xhr;
    };

    // GET
    // =========================================================

    app.get = function (url, data, options = {}) {
        return app.ajax(
            $.extend(true, {}, options, {
                url: url,
                data: data,
                method: 'GET'
            })
        );
    };

    app.getAsync = function (url, data, options = {}) {
        return Promise.resolve(
            app.get(url, data, options)
        );
    };

    app.postAsync = function (url, data, options = {}) {
        return Promise.resolve(
            app.post(url, data, options)
        );
    };

    // POST
    // =========================================================

    app.post = function (url, data, options = {}) {
        return app.ajax(
            $.extend(true, {}, options, {
                url: url,
                data: data,
                method: 'POST'
            })
        );
    };

    // POST JSON
    // =========================================================

    app.postJson = function (url, data, options = {}) {
        return app.ajax(
            $.extend(true, {}, options, {
                url: url,
                data: JSON.stringify(data || {}),
                method: 'POST',
                processData: false,
                contentType: 'application/json; charset=UTF-8'
            })
        );
    };

    // upload
    // =========================================================

    app.upload = function (url, formData, options = {}) {
        return app.ajax(
            $.extend(true, {}, options, {
                url: url,
                method: 'POST',
                data: formData,
                processData: false,
                contentType: false
            })
        );
    };

    // abort all ajax
    // =========================================================

    app.abortAllAjax = function () {
        $.each(app._ajaxPool, function (key, xhr) {
            try {
                xhr.abort();
            } catch (e) {
            }
        });
        app._ajaxPool = {};
    };

    // page destroy hook
    // =========================================================

    $(document).on('pagedestroy.app.ajax', function () {
        app.abortAllAjax();
    });

})(window.MyApp = window.MyApp || {}, window, document, jQuery);
/*!
 * app.modal.js
 * Bootstrap Modal Module
 */
(function (app, window, document, $) {

    'use strict';

    if (!$) throw new Error('jQuery is required');

    // 如果已经初始化，跳过
    if (app._modal_initialized) return app;

    app._modal_initialized = true;


    // defaults
    // =========================================================
    app.defaults = $.extend(true, {modal: {}}, app.defaults || {});

    app.defaults.modal = $.extend(true, {
        id: 'editModal',
        title: '提示',
        bodyId: 'editModalBody',
        backdrop: 'static',
        keyboard: false,
        destroyOnClose: false,
        showLoading: true,
        modalClass: '',
        headers: {
            'X-Page-Mode': 'modal'
        },
        onShow: null,
        onShown: null,
        onHide: null,
        onHidden: null,
        onLoaded: null,

        autoFocus: true,
        loadingText: '加载中...'
    }, app.defaults.modal || {});

    // loading
    // =========================================================
    app.createModalLoading = function () {
        return `
            <div class="d-flex justify-content-center align-items-center py-5">
                <div class="spinner-border text-primary me-3"></div>
                <span>${app.defaults.modal.loadingText}</span>
            </div>
        `;
    };

    // modal html
    // =========================================================
    app.createAjaxModalInnerHTML = function (title, bodyId, modalClass) {
        title = title || '提示';
        bodyId = bodyId || 'editModalBody';
        modalClass = modalClass || '';
        return `
            <div class="modal-dialog modal-dialog-centered ${modalClass}">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">  ${app.escapeHtml(title)} </h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                    </div>
                    <div class="modal-body" id="${bodyId}">
                        ${app.createModalLoading()}
                    </div>
                </div>
            </div>
        `;
    };

    // bind events
    // =========================================================
    app.bindModalEvents = function ($modal, options) {
        $modal.off('.app.modal');
        if ($.isFunction(options.onShow)) {
            $modal.on(
                'show.bs.modal.app.modal',
                options.onShow
            );
        }

        if ($.isFunction(options.onShown)) {
            $modal.on(
                'shown.bs.modal.app.modal',
                options.onShown
            );
        }

        if ($.isFunction(options.onHide)) {
            $modal.on(
                'hide.bs.modal.app.modal',
                options.onHide
            );
        }

        if ($.isFunction(options.onHidden)) {
            $modal.on(
                'hidden.bs.modal.app.modal',
                options.onHidden
            );
        }

        // destroy
        if (options.destroyOnClose === true) {
            $modal.on(
                'hidden.bs.modal.app.modal.destroy',
                function () {
                    const modalInstance =
                        bootstrap.Modal.getInstance($modal[0]);
                    if (modalInstance) {
                        modalInstance.dispose();
                    }
                    $modal.remove();
                }
            );
        }
    };

    // create bootstrap modal
    // =========================================================

    /*!
     * modal instance
     */
    app.getModalInstance = function (target, config = {}) {
        const modalEl = target instanceof jQuery
            ? target[0]
            : target;

        if (!modalEl) {
            return null;
        }

        return bootstrap.Modal.getOrCreateInstance(modalEl, {
            backdrop: config.backdrop ?? 'static',
            keyboard: config.keyboard ?? true,
            focus: config.focus ?? true
        });
    };

    app.createModal = function (options = {}) {
        const opts = $.extend(true, {
            id: 'modal_' + Date.now(),
            title: '提示',
            body: '',
            size: '',
            type: '',
            backdrop: 'static',
            keyboard: false,
            showFooter: true,
            okText: '确定',
            cancelText: '取消',
            okBtnClass: 'btn btn-primary',
            cancelBtnClass: 'btn btn-secondary',
            okLoading: true,
            autoFocus: true,
            destroyOnClose: true,
            draggable: false,
            onShow: null,
            onShown: null,
            onHide: null,
            onHidden: null,
            onOk: null,
            onCancel: null
        }, options);

        // normalize id
        // =====================================================
        const modalId = opts.id.replace(/^#/, '');
        const modalSelector = '#' + modalId;

        // remove existing
        // =====================================================
        $(modalSelector).remove();

        // close btn class
        // =====================================================
        const darkTypes = [
            'modal-primary',
            'modal-danger',
            'modal-success'
        ];

        const closeBtnClass =
            darkTypes.some(t => opts.type.indexOf(t) !== -1)
                ? 'btn-close btn-close-white'
                : 'btn-close';

        // footer
        // =====================================================
        const footerHtml = opts.showFooter
            ? `
                <div class="modal-footer">
                    <button type="button"
                            class="${opts.cancelBtnClass}"
                            data-bs-dismiss="modal">
                        ${opts.cancelText}
                    </button>
                    <button type="button"
                            class="${opts.okBtnClass}"
                            id="${modalId}_ok">
                        ${opts.okText}
                    </button>
                </div>
                `
            : '';

        // html
        // =====================================================
        const html = `
            <div class="modal fade"
                 id="${modalId}"
                 tabindex="-1"
                 aria-hidden="true">
                <div class="modal-dialog
                            modal-dialog-centered
                            ${opts.size}
                            ${opts.type}">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                ${app.escapeHtml(opts.title)}
                            </h5>
                            <button type="button"
                                    class="${closeBtnClass}"
                                    data-bs-dismiss="modal">
                            </button>
                        </div>
                        <div class="modal-body">
                            ${opts.body}
                        </div>
                        ${footerHtml}
                    </div>
                </div>
            </div>
            `;

        $('body').append(html);

        const $modal = $(modalSelector);

        // bootstrap modal
        // =====================================================
        const modal = app.getModalInstance($modal[0], {
            backdrop: opts.backdrop,
            keyboard: opts.keyboard,
            focus: true
        });

        // events
        // =====================================================
        $modal.off('.app.modal');
        if ($.isFunction(opts.onShow)) {
            $modal.on(
                'show.bs.modal.app.modal',
                opts.onShow
            );
        }

        if ($.isFunction(opts.onShown)) {
            $modal.on(
                'shown.bs.modal.app.modal',
                function () {
                    if (opts.autoFocus) {
                        const $input =
                            $modal.find(
                                'input:visible,' +
                                'textarea:visible,' +
                                'select:visible'
                            ).first();
                        if ($input.length) {
                            $input.trigger('focus');
                        }
                    }
                    opts.onShown.call(this);
                }
            );
        }

        if ($.isFunction(opts.onHide)) {
            $modal.on(
                'hide.bs.modal.app.modal',
                opts.onHide
            );
        }

        $modal.on(
            'hidden.bs.modal.app.modal',
            function () {
                if ($.isFunction(opts.onHidden)) {
                    opts.onHidden.call(this);
                }
                if (opts.destroyOnClose === true) {
                    setTimeout(function () {
                        app.destroyModal($modal[0], true);
                    }, 200);
                }
            }
        );

        // ok
        // =====================================================
        if (opts.showFooter && $.isFunction(opts.onOk)) {
            const $okBtn = $('#' + modalId + '_ok');
            $okBtn.off('.app.modal.ok');
            $okBtn.on(
                'click.app.modal.ok',
                async function () {
                    if (opts.okLoading) {
                        app.toggleButtonLoading($okBtn, true);
                    }

                    try {
                        const result =
                            await opts.onOk.call(
                                this,
                                $modal,
                                modal
                            );
                        if (result !== false) {
                            modal.hide();
                        }
                    } catch (e) {
                        if (app.logger?.error) {
                            app.logger.error(e);
                        }
                    } finally {
                        if (opts.okLoading) {
                            app.toggleButtonLoading($okBtn, false);
                        }
                    }
                }
            );
        }

        // cancel
        // =====================================================
        if ($.isFunction(opts.onCancel)) {
            $modal.find('[data-bs-dismiss="modal"]')
                .on(
                    'click.app.modal.cancel',
                    opts.onCancel
                );
        }

        // draggable
        // =====================================================
        if (opts.draggable === true && $.fn.draggable) {
            $modal.find('.modal-dialog')
                .draggable({
                    handle: '.modal-header'
                });
        }

        // show
        // =====================================================
        modal.show();

        return {
            $modal,
            modal,
            id: modalId
        };
    };

    app.showModal = function (target, config = {}) {
        const modal = app.getModalInstance(target, config);
        if (!modal) {
            return null;
        }
        modal.show();
        return modal;
    };

    app.hideModal = function (target) {
        const modalEl = target instanceof jQuery
            ? target[0]
            : target;

        if (!modalEl) {
            return;
        }

        const modal = bootstrap.Modal.getInstance(modalEl);

        if (modal) {
            modal.hide();
        }
    };

    app.destroyModal = function (target, remove = false) {
        const $modal = target instanceof jQuery
            ? target
            : $(target);

        if (!$modal.length) {
            return;
        }

        const modal = bootstrap.Modal.getInstance($modal[0]);
        if (modal) {
            modal.hide();
            modal.dispose();
        }

        $modal.off('.bs.modal');
        $modal.removeData();
        $modal.find('.modal-content').empty();
        if (remove) {
            $modal.remove();
        }

        // cleanup body
        $('body')
            .removeClass('modal-open')
            .css({
                overflow: '',
                paddingRight: ''
            });

        $('.modal-backdrop').remove();
    };

    // show ajax modal
    // =========================================================
    app.showAjaxModal = function (url, $modal, options = {}) {
        if (!url) {
            app.showErrorDialog('modal url is undefined');
            return;
        }

        const opts = $.extend(true, {}, app.defaults.modal, options);
        $modal = $modal || $(opts.id);

        // bind events
        app.bindModalEvents($modal, opts);

        // init modal html
        $modal
            .removeData()
            .html(
                app.createAjaxModalInnerHTML(
                    opts.title,
                    opts.bodyId,
                    opts.modalClass
                )
            );

        // bootstrap modal
        const modalInstance = new bootstrap.Modal($modal[0], {
            backdrop: opts.backdrop,
            keyboard: opts.keyboard
        });

        modalInstance.show();

        // loading
        const $modalBody = $modal.find('#' + opts.bodyId);
        if (opts.showLoading) {
            $modalBody.html(
                app.createModalLoading()
            );
        }

        // ajax load
        app.get(url, {}, {
            dataType: 'html',
            headers: opts.headers,
            showSpinner: false,
            silent: true,
            success(resp) {
                if (typeof resp === 'string') {
                    const $html = $('<div>').html(resp);
                    const $dialog = $html.find('.modal-dialog');
                    if ($dialog.length) {
                        $modal.html($dialog);
                    } else {
                        $modalBody.html(resp);
                    }

                    // page init
                    if ($.isFunction(opts.onLoaded)) {
                        opts.onLoaded.call($modal[0], $modal);
                    }
                }
            },

            error(xhr, type, msg) {
                const resp = xhr.responseText;
                if (resp) {
                    const $html = $('<div>').html(resp);
                    const $dialog = $html.find('.modal-dialog');

                    // 服务端返回的是 modal
                    if ($dialog.length) {
                        $modal.html($dialog);
                        return;
                    }

                    // 普通 html
                    if (resp.indexOf('<') >= 0) {
                        $modalBody.html(resp);
                        return;
                    }
                }

                // 兜底
                $modalBody.html(
                    '<div class="alert alert-danger mb-0">' +
                    app.escapeHtml(xhr.status + ' ' + (xhr.statusText || '系统异常')) +
                    '</div>'
                );
            }
        });

        return modalInstance;
    };

})(window.MyApp = window.MyApp || {}, window, document, jQuery);
/*!
 * app.form.js
 * Form Core Module
 * 兼容传统 jQuery + Bootstrap Admin 后台体系
 */
(function (app, window, document, $) {

    'use strict';

    if (!$) throw new Error('jQuery is required');

    // ✅ 防止重复初始化
    if (app._form_initialized) return app;

    app._form_initialized = true;

    // defaults
    // =========================================================
    app.defaults = $.extend(true, {form: {}}, app.defaults || {});

    app.defaults.form = $.extend(true, {
        method: 'POST',
        json: false,
        resetOnSuccess: false,
        clearErrorOnSubmit: true,
        showSuccessMessage: true,
        showErrorMessage: true,
        successMessage: '操作成功',
        refreshTable: null,
        modal: null,
        triggerButton: null,
        validate: true,
        validateBeforeSubmit: null,
        beforeSubmit: null,
        success: null,
        error: null,
        complete: null,
        ajax: {}
    }, app.defaults.form || {});

    // serialize fields iterator
    // =========================================================
    app.eachSerializedField = function (form, callback, options = {}) {
        const settings = $.extend(true, {
            // 自动规范化:
            normalizeArrayName: true,
            // trim string
            trim: true,
            // 忽略空值
            skipEmpty: false
        }, options);

        const $form = form instanceof jQuery
            ? form
            : $(form);

        if (!$form.length || !$.isFunction(callback)) {
            return;
        }

        $.each($form.serializeArray(), function (_, field) {
            // 忽略空 name
            if (!field.name) {
                return;
            }

            let fieldName = field.name;

            // normalize []
            if (settings.normalizeArrayName) {
                fieldName = fieldName.replace(/\[]$/, '');
            }

            let value = field.value;

            // trim
            if (settings.trim && typeof value === 'string') {
                value = $.trim(value);
            }

            // skip empty
            if (settings.skipEmpty && (value == null || value === '')) {
                return;
            }

            callback(fieldName, value, field);
        });

        return $form;
    };

    // serialize form object
    // =========================================================
    app.serializeForm = function (form, extraParams = {}, options = {}) {
        const result = $.extend(true, {}, extraParams);
        app.eachSerializedField(form, function (fieldName, value) {
            // 已存在 -> 自动数组化
            if (result[fieldName] !== undefined) {
                if (!Array.isArray(result[fieldName])) {
                    result[fieldName] = [result[fieldName]];
                }
                result[fieldName].push(value);
            } else {
                result[fieldName] = value;
            }
        }, options);

        // checkbox unchecked
        $(form).find('input[type=checkbox]').each(function () {
            const $checkbox = $(this);
            let fieldName = $checkbox.attr('name');
            if (!fieldName) {
                return;
            }
            if (options.normalizeArrayName !== false) {
                fieldName = fieldName.replace(/\[]$/, '');
            }
            if (!$checkbox.prop('checked')) {
                if (result[fieldName] === undefined) {
                    const uncheckedValue = $checkbox.data('unchecked-value');
                    if (uncheckedValue !== undefined) {
                        result[fieldName] = uncheckedValue;
                    }
                }
            }
        });
        return result;
    };

    // serialize query params
    // =========================================================
    app.serializeQueryParams = function (form, params = {}, options = {}) {
        const settings = $.extend(true, {
            separator: ','
        }, options);

        app.eachSerializedField(form, function (fieldName, value) {
            // 已存在
            if (params[fieldName] !== undefined) {
                params[fieldName] += settings.separator + value;
            } else {
                params[fieldName] = value;
            }
        }, $.extend(true, {
            skipEmpty: true
        }, settings));

        return params;
    };

    // fill form
    // =========================================================
    app.fillForm = function (form, data = {}) {
        const $form = form instanceof jQuery
            ? form
            : $(form);

        if (!$form.length || !data) {
            return;
        }

        $.each(data, function (name, value) {
            const $fields =
                $form.find('[name="' + name + '"]');

            if (!$fields.length) {
                return;
            }

            $fields.each(function () {
                const $field = $(this);
                const type = ($field.attr('type') || '').toLowerCase();

                // checkbox
                if (type === 'checkbox') {
                    if (Array.isArray(value)) {
                        $field.prop(
                            'checked',
                            value.includes($field.val())
                        );
                    } else {
                        $field.prop(
                            'checked',
                            String(value) === String($field.val())
                        );
                    }
                    return;
                }

                // radio
                if (type === 'radio') {
                    $field.prop(
                        'checked',
                        String(value) === String($field.val())
                    );
                    return;
                }

                // normal
                $field.val(value);
            });

            // select2
            if ($fields.hasClass('select2-hidden-accessible')) {
                $fields.trigger('change');
            }

            // flatpickr
            $fields.each(function () {
                if (this._flatpickr) {
                    this._flatpickr.setDate(value);
                }
            });
        });
    };

    // reset form
    // =========================================================
    app.resetForm = function (form) {
        const $form = form instanceof jQuery
            ? form
            : $(form);

        if (!$form.length) {
            return;
        }

        $form[0].reset();

        // select2
        $form.find('select').each(function () {
            const $select = $(this);
            if ($select.hasClass('select2-hidden-accessible')) {
                $select.val(null)
                    .trigger('change');
            }
        });

        // flatpickr
        $form.find('input').each(function () {
            if (this._flatpickr) {
                this._flatpickr.clear();
            }
        });

        // validation
        $form.removeClass('was-validated');

        $form.find('.is-invalid')
            .removeClass('is-invalid');

        $form.find('.is-valid')
            .removeClass('is-valid');

        app.hideErrorMsg?.();
    };

    // validate form
    // =========================================================
    app.validateForm = function (form) {
        const $form = form instanceof jQuery
            ? form
            : $(form);

        if (!$form.length) {
            return false;
        }

        // bootstrap validate
        if ($form[0].checkValidity) {
            const valid =
                $form[0].checkValidity();

            $form.addClass('was-validated');

            return valid;
        }

        return true;
    };

    // form submit
    // =========================================================
    app.submitForm = function (options = {}) {
        const opts = $.extend(
            true,
            {},
            app.defaults.form,
            options
        );

        // form
        // =====================================================
        const $form = opts.form instanceof jQuery
            ? opts.form
            : $(opts.form);

        if (!$form.length) {
            app.showErrorDialog?.('form not found');

            return $.Deferred()
                .reject('form not found')
                .promise();
        }

        // url
        // =====================================================
        let url = opts.url;
        if (!url) {
            url = $form.attr('action');
        }
        if (!url) {
            app.showErrorDialog?.('form action is undefined');
            return $.Deferred()
                .reject('form action is undefined')
                .promise();
        }

        // validate
        // =====================================================
        if (opts.validate === true) {
            const valid =
                app.validateForm($form);

            if (!valid) {
                return $.Deferred()
                    .reject('form validate failed')
                    .promise();
            }
        }

        // custom validate
        if ($.isFunction(opts.validateBeforeSubmit)) {
            const validateResult = opts.validateBeforeSubmit($form);
            if (validateResult === false) {
                return $.Deferred()
                    .reject('custom validate failed')
                    .promise();
            }
        }

        // before submit
        // =====================================================
        if ($.isFunction(opts.beforeSubmit)) {
            const beforeResult = opts.beforeSubmit($form);
            if (beforeResult === false) {
                return $.Deferred()
                    .reject('beforeSubmit stopped')
                    .promise();
            }
        }

        // clear error
        // =====================================================
        if (opts.clearErrorOnSubmit === true) {
            app.hideErrorMsg?.(
                $form.find('.errorMsgDiv')
            );
        }

        // data
        // =====================================================
        const data = opts.json === true
            ? app.serializeForm($form)
            : $form.serialize();

        // ajax options
        // =====================================================
        const ajaxOptions = $.extend(
            true,
            {},
            opts.ajax,
            {
                url: url,
                method: opts.method,
                data: data,
                triggerButton: opts.triggerButton,
                success(resp) {
                    // success message
                    // =========================================
                    if (opts.showSuccessMessage === true && opts.silent !== true) {
                        app.showSuccessDialog?.(
                            resp.message ||
                            opts.successMessage,
                            1000
                        );
                    }

                    // reset form
                    // =========================================
                    if (opts.resetOnSuccess === true) {
                        app.resetForm($form);
                    }

                    // refresh table
                    // =========================================
                    if (opts.refreshTable) {
                        const $table =
                            opts.refreshTable instanceof jQuery
                                ? opts.refreshTable
                                : $(opts.refreshTable);

                        if ($table.length && $table.bootstrapTable) {
                            $table.bootstrapTable('refresh');
                        }
                    }

                    // close modal
                    // =========================================
                    if (opts.modal) {
                        app.hideModal(
                            opts.modal
                        );
                    }

                    // callback
                    // =========================================
                    if ($.isFunction(opts.success)) {
                        opts.success(
                            resp,
                            $form
                        );
                    }
                },
                error(xhr, type, msg, resp) {

                    // business error
                    // =========================================
                    if (
                        opts.showErrorMessage === true &&
                        type === 'business'
                    ) {
                        const $errorDiv =
                            $form.find('.errorMsgDiv');

                        if ($errorDiv.length && app.showErrorMsg) {
                            app.showErrorMsg(msg, $errorDiv);
                        }
                    }

                    // callback
                    // =========================================
                    if ($.isFunction(opts.error)) {
                        opts.error(
                            xhr,
                            type,
                            msg,
                            resp,
                            $form
                        );
                    }
                },

                complete(resp, textStatus) {
                    if ($.isFunction(opts.complete)) {
                        opts.complete(
                            resp,
                            textStatus,
                            $form
                        );
                    }
                }
            }
        );


        // json
        // =====================================================
        if (opts.json === true) {
            return app.postJson(
                url,
                app.serializeForm($form),
                ajaxOptions
            );
        }


        // normal form
        // =====================================================
        return app.post(
            url,
            $form.serialize(),
            ajaxOptions
        );
    };

    app.submitFormAsync = function (options = {}) {
        return Promise.resolve(
            app.submitForm(options)
        );
    };

    // upload form
    // =========================================================
    app.submitUploadForm = function (options = {}) {
        const opts = $.extend(
            true,
            {},
            app.defaults.form,
            options
        );

        const $form = opts.form instanceof jQuery
            ? opts.form
            : $(opts.form);

        if (!$form.length) {
            app.showErrorDialog?.(
                'upload form not found'
            );

            return $.Deferred()
                .reject()
                .promise();
        }

        const formData = new FormData($form[0]);

        return app.upload(
            opts.url || $form.attr('action'),
            formData,
            $.extend(true, {}, opts.ajax, {
                triggerButton:
                opts.triggerButton,

                success(resp) {
                    if (opts.showSuccessMessage !== false) {
                        app.showSuccessDialog?.(
                            resp.message ||
                            opts.successMessage,
                            1000
                        );
                    }

                    if ($.isFunction(opts.success)) {
                        opts.success(resp, $form);
                    }
                },

                error(xhr, type, msg, resp) {
                    if ($.isFunction(opts.error)) {
                        opts.error(
                            xhr,
                            type,
                            msg,
                            resp,
                            $form
                        );
                    }
                }
            })
        );
    };

    // quick methods
    // =========================================================
    app.commonDoAdd = function (url, options = {}, $modal, $form) {
        return app.submitForm({
            url: url,
            form: $form || '#editModalDataForm',
            modal: $modal || '#editModal',
            triggerButton: options.triggerButton || '#doAddBtn',
            refreshTable: options.refreshTable || '#data_table',
            successMessage: '新增成功',
            ...options
        });
    };

    app.commonDoUpdate = function (url, options = {}, $modal, $form) {
        return app.submitForm({
            url: url,
            form: $form || '#editModalDataForm',
            modal: $modal || '#editModal',
            triggerButton: options.triggerButton || '#doUpdateBtn',
            refreshTable: options.refreshTable || '#data_table',
            successMessage: '修改成功',
            ...options
        });
    };

    // auto bind submit
    // =========================================================
    $(document).on(
        'submit.app.form',
        'form[data-auto-submit=true]',
        function (e) {
            e.preventDefault();
            const $form = $(this);
            app.submitForm({
                form: $form,
                url: $form.attr('action'),
                method: $form.attr('method') || 'POST',
                triggerButton: $form.find('[type=submit]').first()
            });
        }
    );

    // page destroy
    // =========================================================
    $(document).on(
        'pagedestroy.app.form',
        function () {
            $('form').off('.app.form');
        }
    );

})(window.MyApp = window.MyApp || {}, window, document, jQuery);
/*!
 * app.table.js
 * Bootstrap Table Module
 * 提供 Bootstrap Table 相关的工具方法和集成
 */
(function (app, window, document, $) {

    'use strict';

    if (!$) throw new Error('jQuery is required');

    // 如果已经初始化，跳过
    if (app._table_initialized) return app;

    app._table_initialized = true;

    app.defaults = $.extend(true, {
        table: {
            selector: '#data_table',
            searchForm: '#search_form',
            uniqueId: 'id',
            pageSize: 10,
            sidePagination: 'server',
            method: 'get',
            mobileCardView: true,
            autoRefresh: false,
            debounceRefresh: 150
        }
    }, app.defaults || {});


    /**
     * 获取 jQuery 对象
     */
    function resolveTable($table) {
        if (!$table)
            return $(app.defaults.table.selector);

        return $table instanceof $ ? $table : $($table);
    }

    /**
     * 获取 form
     */
    function resolveForm($form) {
        if (!$form)
            return $(app.defaults.table.searchForm);

        return $form instanceof $ ? $form : $($form);
    }

    /**
     * 是否已初始化
     */
    function isInitialized($table) {
        return !!$table.data('bs.table.initialized');
    }

    /**
     * 解析 Ajax 错误
     */
    function parseTableError(xhr) {
        if (!xhr)
            return '未知错误';

        try {
            const json = JSON.parse(xhr.responseText);
            return json.message
                || json.msg
                || xhr.statusText
                || '请求失败';
        } catch (e) {
            return xhr.responseText
                || xhr.statusText
                || '请求失败';
        }
    }

    /**
     * 安全执行函数
     */
    function safeCallback(fn, context) {
        return function () {
            if (!$.isFunction(fn)) {
                return;
            }

            try {
                return fn.apply(context || this, arguments);
            } catch (e) {
                if (app.error) {
                    app.error(e);
                } else {
                    console.error(e);
                }
            }
        };
    }

    // ======================== Formatter 工厂 ========================
    app.tableFormatters = app.tableFormatters || {};

    /**
     * 文本格式化
     *
     * options:
     * {
     *     maxLength: 20,       // 最大显示字符数
     *     truncate: true,      // 是否按字符截断
     *     ellipsis: true,      // 截断后是否追加...
     *     expandable: true,    // 是否使用 <details> 展开全文
     *     tooltip: true,       // 是否显示 title
     *     multiline: false,    // 是否允许换行
     *     escapeHtml: true,    // 是否转义 HTML
     *     emptyText: ''        // 空值显示
     * }
     */
    app.tableFormatters.text = function (options = {}) {
        const config = $.extend({
            maxLength: 20,
            truncate: true,
            ellipsis: true,
            expandable: true,
            tooltip: true,
            multiline: false,
            escapeHtml: true,
            emptyText: ''
        }, options);

        return function (value) {
            if (value === null || value === undefined || value === '') {
                return config.emptyText;
            }

            const rawText = typeof value === 'object'
                ? JSON.stringify(value)
                : String(value);

            const fullText = config.escapeHtml
                ? app.escapeHtml(rawText)
                : rawText;

            let displayText = fullText;

            // 是否按字符截断
            if (
                config.truncate &&
                Number.isInteger(config.maxLength) &&
                config.maxLength > 0 &&
                rawText.length > config.maxLength
            ) {
                displayText = fullText.substring(0, config.maxLength);

                if (config.ellipsis) {
                    displayText += '...';
                }
            }

            const tooltipAttr = config.tooltip
                ? ` title="${fullText}"`
                : '';

            // 可展开
            if (config.expandable) {
                return `
                    <details class="text-break">
                        <summary class="text-truncate list-style-none"${tooltipAttr}>
                            ${displayText}
                        </summary>
                        <div class="mt-1 text-wrap text-break">
                            ${fullText}
                        </div>
                    </details>`;
            }

            // 多行
            if (config.multiline) {
                return `
                    <div class="text-wrap text-break"${tooltipAttr}>
                        ${displayText}
                    </div>`;
            }

            // 单行
            return `
                <span class="d-inline-block text-truncate"
                      style="max-width:100%;vertical-align:bottom;"
                      ${tooltipAttr}>
                    ${displayText}
                </span>`;
        };
    };

    /**
     * JSON Formatter
     */
    app.tableFormatters.json = function () {
        return function (value) {
            if (value === null || value === undefined)
                return '';

            const text = typeof value === 'object'
                ? JSON.stringify(value, null, 4)
                : String(value);

            const safeText = app.escapeHtml(text);

            return `
                <details>
                    <summary class="d-block text-truncate list-style-none text-muted">
                        ${safeText}
                    </summary>
                    <pre class="mb-0 text-wrap">${safeText}</pre>
                </details>
            `;
        };
    };

    /**
     * 日期 Formatter
     */
    app.tableFormatters.datetime = function (format = 'YYYY-MM-DD HH:mm:ss') {
        return function (value) {
            if (!value)
                return '';

            try {
                return app.formatDate(new Date(value), format);
            } catch (e) {
                return value;
            }
        };
    };

    /**
     * 数字单位 Formatter
     */
    app.tableFormatters.numUnit = function (decimal = 2, maxNumLen, withColor = false) {
        return function (value) {
            if (value === null || value === undefined || value === '')
                return '';

            const formatted = app.formatNumUnit(value, decimal, maxNumLen);
            if (!withColor) {
                return formatted;
            }

            if (value > 0) {
                return `<span class="color-red">${formatted}</span>`;
            }

            if (value < 0) {
                return `<span class="color-green">${formatted}</span>`;
            }

            return formatted;
        };
    };

    /**
     * Choice Formatter
     */
    app.tableFormatters.choice = function (choiceMap = {}, defaultValue = '未知') {
        return function (value) {
            const key = String(value);
            const item = choiceMap[key];
            if (!item) {
                return `<span class="text-secondary">${defaultValue}</span>`;
            }
            const text = app.escapeHtml(item.text || defaultValue);
            return `<span class="${item.class || ''}">${text}</span>`;
        };
    };

    /**
     * 行号 Formatter
     */
    app.tableFormatters.lineNumber = function ($table) {
        $table = resolveTable($table);
        return function (value, row, index) {
            const options = $table.bootstrapTable('getOptions');
            const pageSize = options.pageSize || 10;
            const pageNumber = options.pageNumber || 1;
            return (pageNumber - 1) * pageSize + index + 1;
        };
    };

    /** 金额格式化（带￥，保留两位小数，空值显示 -） */
    app.tableFormatters.money = function () {
        return function (value, row, index) {
            if (value === null || value === undefined || value === '')
                return '<span class="text-muted">-</span>';
            return '￥' + Number(value).toFixed(2);
        };
    };

    /** 直接渲染后端返回的带样式 badge HTML，空值显示 - */
    app.tableFormatters.badgeHtml = function () {
        return function (value, row, index) {
            if (value === null || value === undefined || value === '')
                return '<span class="text-muted">-</span>';
            return value;
        };
    };

    // ======================== Bootstrap Table ========================

    /**
     * 通用 Bootstrap Table 初始化
     */
    app.commonBootstrapTable = function ($table, options = {}) {
        $table = resolveTable($table);
        if (!$table.length) {
            console.warn('table element not found');
            return null;
        }

        const defaultOptions = {
            method: app.defaults.table.method,
            striped: true,
            cache: false,
            pagination: true,
            sortOrder: 'desc',
            sidePagination: app.defaults.table.sidePagination,
            pageNumber: 1,
            pageSize: app.defaults.table.pageSize,
            paginationSuccessivelySize: 2,
            paginationPagesBySide: 1,
            pageList: [1, 5, 10, 50, 100],
            clickToSelect: true,
            theadClasses: 'thead-light',
            uniqueId: app.defaults.table.uniqueId,
            toolbar: '#toolbar',
            buttonsClass: 'primary btn-sm',
            showColumns: true,
            showRefresh: true,
            showJumpTo: true,
            silent: false,
            loadingFontSize: '2em',
            cardView: !!(app.isMobile && app.defaults.table.mobileCardView),
            undefinedText: '',
            onPostBody: function () {
                $('.page-jump-to').addClass('input-group-sm');
            },
            onLoadSuccess: safeCallback(function (data) {
                if (app.debug) {
                    console.log('[BootstrapTable] load success', data);
                }
            }),

            onLoadError: safeCallback(function (status, xhr) {
                // 登录失效
                if (xhr.status === 401) {
                    if (app.redirectToLogin) {
                        app.redirectToLogin();
                    }
                    return;
                }

                const message = parseTableError(xhr);
                if (app.showErrorDialog) {
                    app.showErrorDialog(message);
                } else {
                    alert(message);
                }
            }),

            loadingTemplate: function () {
                return `
                    <div class="text-success text-center p-1">
                        <i class="fas fa-spinner fa-spin fa-fw"></i>
                        <span class="ml-2">请稍等，正在加载中...</span>
                    </div>
                `;
            },

            formatLoadingMessage: function () {
                return `
                    <span class="text-success">
                        <i class="fas fa-spinner fa-spin"></i>
                        <span class="ml-2">请稍等，正在加载中...</span>
                    </span>
                `;
            },

            formatNoMatches: function () {
                return `
                    <span class="text-danger">
                        <i class="fas fa-times"></i>
                        <span class="ml-2">没有相关的匹配结果</span>
                    </span>
                `;
            }
        };

        const opts = $.extend(true, {}, defaultOptions, options);

        // 已初始化 → refreshOptions
        if (isInitialized($table)) {
            $table.bootstrapTable('refreshOptions', opts);
            return $table;
        }

        // 初始化
        $table
            .bootstrapTable(opts)
            .data('bs.table.initialized', true);

        return $table;
    };

    /**
     * 实体表格
     */
    app.commonBsTableEntity = function (
        url,
        columns,
        options,
        $table,
        $form
    ) {
        $table = resolveTable($table);
        $form = resolveForm($form);

        const bsTable = {
            init: function () {
                const opts = $.extend(true, {
                    url: url,
                    columns: columns,
                    queryParams: bsTable.queryParams,
                    rowStyle: bsTable.rowStyle,
                    headerStyle: bsTable.headerStyle,
                    footerStyle: bsTable.footerStyle,
                    onDblClickRow: safeCallback(bsTable.onDblClickRow),
                    onLoadSuccess: safeCallback(bsTable.onLoadSuccess),
                    showToggle: true
                }, options || {});

                return app.commonBootstrapTable($table, opts);
            },

            refresh: function (params) {
                return app.commonRefreshTable($table, params);
            },

            destroy: function () {
                return app.destroyBootstrapTable($table);
            },

            queryParams: function (params) {
                if (app.serializeForm)
                    return app.serializeForm($form, params);

                return params;
            },

            onDblClickRow: function () {
            },

            onLoadSuccess: function () {
            },

            rowStyle: function () {
                return {};
            },

            headerStyle: function () {
                return {};
            },

            footerStyle: function () {
                return {};
            }
        };

        return bsTable;
    };

    // ======================== 刷新 ========================
    app.commonRefreshTable = function ($table, params = {}) {
        $table = resolveTable($table);
        if (!isInitialized($table)) {
            return;
        }

        $table.bootstrapTable('refresh', params);
    };

    app.doQuery = function ($table = null, params = {}) {
        app.commonRefreshTable($table, params);
    };

    // ======================== 销毁 ========================
    app.destroyBootstrapTable = function ($table) {
        $table = resolveTable($table);
        if (!isInitialized($table)) {
            return;
        }

        try {
            $table.bootstrapTable('destroy');
        } catch (e) {
            console.error(e);
        } finally {
            $table.removeData('bs.table.initialized');
        }
    };

    // ======================== Selection ========================
    app.getTableSelections = function ($table) {
        $table = resolveTable($table);
        if (!isInitialized($table)) {
            return [];
        }

        return $table.bootstrapTable('getSelections') || [];
    };

    app.getTableSelectionIds = function ($table, field = 'id') {
        return app.getTableSelections($table)
            .map(item => item[field])
            .filter(Boolean);
    };

    app.commonGetIdSelections = function ($table) {
        return app.getTableSelectionIds($table).join(',');
    };

    // ======================== Params ========================
    app.commonGetBsTableParams = function ($table) {
        $table = resolveTable($table);
        if (!isInitialized($table)) {
            return {};
        }

        const tableOptions = $table.bootstrapTable('getOptions');
        let params = {};
        if (tableOptions.queryParamsType === 'limit') {
            params = {
                sort: tableOptions.sortName || '',
                order: tableOptions.sortOrder || 'asc'
            };

            if (tableOptions.pagination && tableOptions.sidePagination === 'server') {
                const isAllRows = tableOptions.pageSize === tableOptions.formatAllRows();
                params.offset = isAllRows
                    ? 0
                    : tableOptions.pageSize * (tableOptions.pageNumber - 1);

                params.limit = tableOptions.pageSize;
                if (params.limit === 0 || isAllRows) {
                    delete params.limit;
                }
            }
        }

        return params;
    };

    // ======================== Debounce Refresh ========================
    if ($.debounce) {
        app.debounceRefreshTable = $.debounce(
            app.defaults.table.debounceRefresh,
            function ($table, params) {
                app.commonRefreshTable($table, params);
            }
        );
    }

    // ======================== 页面销毁 ========================
    $(document)
        .off('pagedestroy.app.table')
        .on('pagedestroy.app.table', function () {
            $('[data-toggle="table"], #data_table, .bootstrap-table table').each(function () {
                app.destroyBootstrapTable($(this));
            });
        });


})(window.MyApp = window.MyApp || {}, window, document, jQuery);


/*!
 * app.crud.js
 * CRUD Module
 */
(function (app, window, document, $) {

    'use strict';

    if (!$) throw new Error('jQuery is required');

    // ✅ 防止重复初始化
    if (app._crud_initialized) return app;

    app._crud_initialized = true;


    // defaults
    // =====================================================
    app.defaults = $.extend(true, {crud: {}}, app.defaults || {});

    app.defaults.crud = $.extend(true, {
        confirmTitle: '确认操作',
        deleteConfirmTitle: '确认删除',
        deleteConfirmText: '',
        deleteSuccessMessage: '删除成功',
        triggerButton: null,
        refreshTable: '#data_table',
        showSuccessMessage: true,
        confirm: true
    }, app.defaults.crud || {});

    // request
    // =====================================================
    app.crudRequest = function (options = {}) {
        const opts = $.extend(
            true,
            {},
            app.defaults.crud,
            options
        );

        if (!opts.url) {
            app.showErrorDialog?.('url is undefined');
            return $.Deferred()
                .reject('url is undefined')
                .promise();
        }

        const request = function () {
            return app.post(
                opts.url,
                opts.data || {},
                {
                    triggerButton:
                    opts.triggerButton,
                    success(resp) {
                        // success dialog
                        // =================================
                        if (opts.showSuccessMessage !== false) {

                            app.showSuccessDialog?.(
                                resp.message ||
                                opts.successMessage ||
                                '操作成功',
                                1000
                            );
                        }

                        // refresh table
                        // =================================
                        if (opts.refreshTable) {
                            const $table = opts.refreshTable instanceof jQuery
                                ? opts.refreshTable
                                : $(opts.refreshTable);
                            if ($table.length && $table.bootstrapTable) {
                                $table.bootstrapTable('refresh');
                            }
                        }

                        // callback
                        // =================================
                        if ($.isFunction(opts.success)) {
                            opts.success(resp);
                        }
                    },
                    error(xhr, type, msg, resp) {
                        if (opts.showErrorMessage !== false) {
                            app.showErrorDialog?.(msg || '操作失败');
                        }

                        if ($.isFunction(opts.error)) {
                            opts.error(
                                xhr,
                                type,
                                msg,
                                resp
                            );
                        }
                    },
                    complete(resp, status) {
                        if ($.isFunction(opts.complete)) {
                            opts.complete(resp, status);
                        }
                    }
                }
            );
        };

        // confirm
        // =============================================
        if (opts.confirm === true) {
            app.confirm(
                opts.confirmTitle,
                opts.confirmText,
                request
            );
            return;
        }

        return request();
    };

    // delete by id
    // =====================================================
    app.deleteById = function (url, id, options = {}) {
        if (!id) {
            app.showErrorDialog?.('id error');
            return;
        }

        return app.crudRequest({
            url: url,
            data: {id},
            confirmTitle: options.confirmTitle || '确认删除',
            confirmText: options.confirmText || '',
            successMessage: options.successMessage || '删除成功',

            ...options
        });
    };

    // batch delete
    // =====================================================
    app.batchDelete = function (url, ids, options = {}) {
        if (
            !ids ||
            !Array.isArray(ids) ||
            ids.length === 0
        ) {
            app.showErrorDialog?.('请选择要删除的记录');
            return;
        }

        return app.crudRequest({
            url: url,
            data: {
                ids: ids.join(',')
            },
            triggerButton: options.triggerButton || '#deleteByIdsBtn',
            confirmTitle: options.confirmTitle || '确认删除',
            confirmText: options.confirmText || '',
            successMessage: options.successMessage || '删除成功',

            ...options
        });
    };

    // save helper
    // =====================================================
    app.save = function (options = {}) {
        return app.submitForm(options);
    };

    // common add
    // =====================================================
    app.add = function (url, options = {}) {
        return app.commonDoAdd(
            url,
            options
        );
    };

    // common update
    // =====================================================
    app.update = function (url, options = {}) {
        return app.commonDoUpdate(
            url,
            options
        );
    };

    // selected ids
    // =====================================================
    app.getSelectedIds = function (
        table = '#data_table',
        field = 'id'
    ) {
        const $table = table instanceof jQuery
            ? table
            : $(table);

        if (!$table.length || !$table.bootstrapTable) {
            return [];
        }

        const rows =
            $table.bootstrapTable('getSelections');

        return $.map(rows, function (row) {
            return row[field];
        });
    };

    // delete selected
    // =====================================================
    app.deleteSelected = function (url, options = {}) {
        const ids =
            app.getSelectedIds(
                options.table || '#data_table',
                options.idField || 'id'
            );

        if (!ids.length) {
            app.showErrorDialog?.('请选择行');
            return;
        }

        return app.batchDelete(
            url,
            ids,
            options
        );
    };

})(window.MyApp = window.MyApp || {}, window, document, jQuery);
/**
 * 绑定节流 (throttle) 处理程序到 `resize` 事件
 * NOTE: 请不要更改显示顺序（例如 1a, 1b, 2a, 2b...等）
 */
$(window).resize(
    $.throttle(app_config.throttleDelay, function (e) {
        /**
         * (1a) 当窗口宽度低于特定值时，添加类 (移动端菜单)
         * 说明：当导航栏被调整大小时，监视 #CONTENT 和 NAV 的最小宽度。
         * 这样做是为了在许多桌面和移动设备上避免最小页面宽度的错误。
         */
        AppInit.mobileCheckActivation();

        /**
         * (1b) 检查导航状态（判断是水平导航还是垂直导航）
         * 说明：触发一个事件来检查导航方向。
         * 根据条件，它将初始化或销毁 PerfectScrollbar，或激活/禁用水平导航插件。
         */
        AppInit.checkNavigationOrientation();

        /** -- 在此行下方插入你的 `resize` 相关代码 -- **/

    })
);


/**
 * Bind the throttled handler to the scroll event
 **/
$(window).scroll(
    $.throttle(app_config.throttleDelay, function (e) {
        /**
         * FIX APP HEIGHT
         * Compare the height of nav and content;
         * If one is longer/shorter than the other, measure them to be equal.
         * This event is only fired on desktop.
         **/
        /** -- insert your other scroll codes below this line -- **/
    })
);

/**
 * Initiate scroll events
 **/
$(window).on('scroll', AppInit.windowScrollEvents);

/**
 * 当页面加载完成时发设置
 * DOCUMENT LOADED EVENT
 * DOC: Fire when DOM is ready
 * Do not change order a, b, c, d...
 **/
jQuery(document).ready(function () {

    console.log(`%c${app_config.logStyleMap.info.icon} starting init`, app_config.logStyleMap.info.style);

    /**
     * 检测访问设备是 PC 还是手机
     **/
    AppInit.addDeviceType();

    /**
     * 检测浏览器内核
     **/
    AppInit.detectBrowserType();

    /**
     * 检查手机视图宽度时添加 CSS class .mobile-view-activated
     * a. check for mobile view width and add class .mobile-view-activated
     **/
    AppInit.mobileCheckActivation();

    /**
     * b.导航设置
     * b. build navigation
     **/
    AppInit.buildNavigation(app_config.navHooks);

    /**
     * c. 导航检索
     * c. initialize nav filter
     **/
    AppInit.listFilter(app_config.navHooks, app_config.navFilterInput, app_config.navAnchor);

    /**
     * d. 其它各种设置
     * d. run DOM misc functions
     **/
    AppInit.domReadyMisc();

    /**
     * APP AJAX REQUEST SETUP
     * 执行并获取所有ajax请求
     * updates naivgation elements to active
     */
    AppInit.navAsAjax();

    /**
     * e. 初始化滑动导航（手机适配）
     * e. init swipe navigation for mobile
     * 支持右滑显示导航菜单，左滑关闭导航菜单
     **/
    AppInit.initSwipeNavigation();

    /**
     * ✅ 全局 AJAX 拦截配置
     * $.ajax 请求失败
     *    ↓
     * 其它方法 所有通过 $.ajax / $.get / $.post / bootstrapTable 发出的请求 内部 error 回调
     *    ↓
     * 👉 触发你配置的 onLoadError   （你写的）
     *    ↓
     * jQuery 触发全局 ajaxError     （全局拦截）
     *    ↓
     * ajaxSetup.complete            （如果配置了）
     *
     */
    (function initAjaxGlobal() {
        // 🔹 1. 请求前拦截（加 token / header）
        $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
            const token = localStorage.getItem('token');
            if (token) {
                jqXHR.setRequestHeader('Authorization', 'Bearer ' + token);
            }
        });

        // 🔹 2. 请求完成（统一处理所有响应）
        $.ajaxSetup({
            complete: function (xhr) {
                // 401 未登录
                if (xhr.status === 401) {
                    AppInit.redirectToLogin();
                }
            }
        });

        // 🔹 3. 请求失败（网络 / 500 等）
        $(document).ajaxError(function (event, xhr, settings) {
            // 可以在这里添加统一的错误日志
        });

        // 🔹 4. 🔥 AJAX 完成后检测 HTML 响应是否为登录页
        $(document).ajaxComplete(function (event, xhr, settings) {
            // 只处理 HTML 类型的请求
            const dataType = settings.dataType || '';
            const contentType = xhr.getResponseHeader('Content-Type') || '';

            // 如果响应是 HTML
            if (dataType === 'html' || contentType.includes('text/html')) {
                const responseText = xhr.responseText;
                if (responseText && typeof responseText === 'string') {
                    // 🔥 检测是否返回了登录页面（多种方式检测）
                    const isLoginPage = responseText.includes('loginForm') && responseText.includes('btnLogin');
                    if (isLoginPage) {
                        console.warn('[AJAX] 检测到登录页面，跳转至登录...');
                        AppInit.redirectToLogin();
                    }
                }
            }
        });

    })();
});

/**
 * 监听移动设备的屏幕方向变化事件
 * DOC: 重新计算应用高度，确保 UI 适配不同方向
 */
$(window).on("orientationchange", function (event) {

    /**
     * 计算并设置应用容器的高度
     * 适配屏幕旋转，确保界面填充整个视口
     */
    function appHeight() {
        let winHeight = window.innerHeight; // 兼容不同设备的窗口高度
        let headerHeight = document.querySelector(".page-header")?.offsetHeight || 0;
        let footerHeight = document.querySelector(".page-footer")?.offsetHeight || 0;

        // 计算内容区高度
        let contentHeight = winHeight - headerHeight - footerHeight;

        // 设置内容区最小高度，确保不会溢出
        document.querySelectorAll(".app-container, .page-content").forEach(el => {
            el.style.minHeight = `${contentHeight}px`;
        });

        // Debug 模式打印日志
        if (app_config.debugState) {
            console.log(
                `%cappHeight 计算完成: 窗口高度 ${winHeight}px, 内容区高度 ${contentHeight}px`,
                "color: blue; font-weight: bold;"
            );
        }
    }

    // 初始化
    document.addEventListener("DOMContentLoaded", appHeight);

    // 清除可能受方向影响的 CSS 高度
    $("body, .app-container").css("height", "auto");

    // 触发应用高度重新计算的逻辑（假设 appHeight() 负责此任务）
    if (typeof appHeight === "function") {
        appHeight();
    }

    // 如果开启调试模式，打印日志
    if (app_config.debugState) {
        let angle = screen.orientation?.angle || 0; // 获取当前屏幕旋转角度（0, 90, -90, 180）
        console.log(`%c屏幕方向变化: ${angle}°`, app_config.logStyleMap.info.style);
    }
});
/**
 * Window load function
 * DOC: 监听窗口的焦点（focus）和失焦（blur）事件
 */
$(window).on("blur focus", function (e) {
    const $window = $(this);
    const prevType = $window.data("prevType") || "";

    // 确保 app_config 存在且已正确初始化
    if (typeof app_config !== "undefined" && app_config.root_) {
        // 仅在事件类型发生变化时执行逻辑，避免重复操作
        if (prevType !== e.type) {
            let isBlur = e.type === "blur";

            app_config.root_.toggleClass("blur", isBlur);

            // if (app_config.debugState) {
            //     console.log(`%c窗口${isBlur ? "失焦" : "聚焦"}`, isBlur ? app_config.logStyleMap.warn.style : app_config.logStyleMap.success.style);
            // }
        }
    }

    // 记录当前事件类型，避免重复触发相同的逻辑
    $window.data("prevType", e.type);
});
/*!
 * MyApp - 前端通用工具模块 (重构版)
 * 保持全部原有功能，优化代码结构、错误处理、可读性
 */
window.MyApp = window.MyApp || {};

const MyApp = (function (app, window, document, $) {

    'use strict';

    // ======================== 依赖初始化 ========================
    app.context_path = AppInit.context_path || '';
    app.toggleSpinner = AppInit.toggleSpinner;
    app.showSpinner = AppInit.showSpinner;
    app.hideSpinner = AppInit.hideSpinner;
    app.showLoading = AppInit.showSpinner;
    app.hideLoading = AppInit.hideSpinner;
    app.confirm = AppInit.confirm;
    app.showSuccessDialog = AppInit.showSuccessDialog;
    app.showErrorDialog = AppInit.showErrorDialog;
    app.showErrorMsg = AppInit.showErrorMsg;
    app.hideErrorMsg = AppInit.hideErrorMsg;
    app.showSuccessMsg = AppInit.showSuccessMsg;
    app.formatDate = AppInit.formatDate;
    app.formatNumUnit = AppInit.formatNumUnit;
    app.escapeHtml = AppInit.escapeHtml
    app.redirectToLogin = AppInit.redirectToLogin

    // ======================== 工具函数 ========================
    /**
     * 防抖函数
     * @param {Function} fn
     * @param {number} delay
     * @returns {Function}
     */
    app.debounce = app.utils.func.debounce;

    // ======================== DOM 辅助 ========================
    app.init = function () {
        document.querySelectorAll('.enter-query').forEach(input => {
            input.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.keyCode === 13) {
                    event.preventDefault();
                    app.doQuery();
                }
            });
        });
    };

    app.doCheckAll = function (obj, chkItem) {
        const checkboxes = app.getElementsByClassName(document, chkItem);
        for (let i = 0; i < checkboxes.length; i++) {
            checkboxes[i].checked = obj.checked;
        }
    };

    app.validCheckAll = function (obj, chkItem, chkall) {
        if (!obj.checked) {
            document.getElementById(chkall).checked = false;
            return;
        }
        const checkboxes = app.getElementsByClassName(document, chkItem);
        let allChecked = true;
        for (let i = 0; i < checkboxes.length; i++) {
            if (!checkboxes[i].checked) {
                allChecked = false;
                break;
            }
        }
        document.getElementById(chkall).checked = allChecked;
    };

    app.getElementsByClassName = function (node, className) {
        if (node.getElementsByClassName) {
            return node.getElementsByClassName(className);
        }
        // fallback for older browsers
        const results = [];
        const elements = node.getElementsByTagName('input');
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].className.indexOf(className) !== -1) {
                results.push(elements[i]);
            }
        }
        return results;
    };

    app.getCheckedIds = function (node, className = 'chkItem') {
        const checkboxes = app.getElementsByClassName(node, className);
        const ids = [];
        for (let i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked) ids.push(checkboxes[i].value);
        }
        return ids.join(',');
    };

    app.initSelect2 = function (el, options) {
        const opts = {
            theme: 'bootstrap-5',
            width: $(el).data('width') || ($(el).hasClass('w-100') ? '100%' : '100%'),
            placeholder: $(el).data('placeholder'),
        };
        $.extend(opts, options);
        $('.select2').select2(opts);
    };

    app.showToast = function (msg, css, delay, $element) {
        const $toast = $element || $('#liveToast');
        $toast.find('.toast-body').html(msg);
        const $bodyContainer = $toast.find('#bodyContainer');
        if (css === 'success') {
            $bodyContainer.removeClass().addClass('d-flex alert-success');
        } else if (css === 'error') {
            $bodyContainer.removeClass().addClass('d-flex alert-danger');
        } else {
            $bodyContainer.removeClass().addClass('d-flex alert-light');
            if (css !== undefined && delay === undefined) {
                const num = parseInt(css);
                if (!isNaN(num) && num > 0) delay = num;
            }
        }
        const toast = new bootstrap.Toast($toast, {delay: delay || 1000});
        toast.show();
    };

    // ======================== 密码修改 ========================
    app.goModifyPassword = function (url, userId) {
        if (!url)
            url = app.context_path + '/admin/sys/user/modifyPassword';

        if (userId)
            url += '?id=' + encodeURIComponent(userId);

        // 防重复 modal
        $('#modifyPasswordModal').remove();

        // create modal
        const $modal = $(`
            <div
                class="modal fade"
                id="modifyPasswordModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabindex="-1"
                aria-hidden="true">
            </div>
    
        `);
        $('body').append($modal);
        app.showAjaxModal(
            url,
            $modal,
            {
                title: '修改密码',
                showSpinner: true,
                onHidden() {
                    app.destroyModal($modal, true);  // destroy modal
                },
                success() {
                    app.logger?.info?.('[ModifyPasswordModal Loaded]');
                },
                error(xhr, type, msg) {
                    app.showErrorDialog(msg || '加载失败');
                    app.destroyModal($modal, true);
                }
            }
        );
    };

    app.doModifyPassword = function (url) {
        app.logger?.info?.('🔹 entering doModifyPassword');
        const $modal = $('#modifyPasswordModal');
        const $form = $('#modifyPasswordForm');
        const $errorDiv = $modal.find('.errorMsgDiv');
        const params = app.serializeQueryParams($form, {});

        // 前端校验
        if (!params.originalPassword) {
            app.showErrorMsg('请输入原密码', $errorDiv);
            return;
        }

        if (!params.newPassword) {
            app.showErrorMsg('请输入新密码', $errorDiv);
            return;
        }

        if (params.newPassword !== params.confirmPassword) {
            app.showErrorMsg('两次密码输入不一致', $errorDiv);
            return;
        }

        app.hideErrorMsg($errorDiv);
        if (!url)
            url = app.context_path + '/admin/sys/user/modifyPassword'

        app.post(
            url,
            params,
            {
                triggerButton: '#btnDoModifyPassword',
                showSpinner: true,
                showError: false,
                showBusinessError: false,
                success(resp) {
                    $modal.modal('hide');
                    app.showSuccessDialog(resp.message || '密码修改成功', 1000);

                    // 清空表单
                    $form[0]?.reset();
                },
                error(xhr, type, msg) {
                    app.showErrorMsg(msg || '操作失败', $errorDiv);
                    app.logger?.error?.('[modifyPassword error]', {
                            type,
                            msg
                        }
                    );
                }
            }
        );
    };

    // ======================== 分页组件 ========================
    app.buildPaginatin = function (page, totalPages) {
        let pagination = `
            <nav class="navigation d-flex justify-content-center mt-3">
                <ul class="pagination justify-content-center">
                    <li class="page-item ${page === 1 ? 'disabled' : ''}">
                        <a class="page-link" href="javascript:void(0)" onclick="MySearch.goToPage(${page - 1})">上一页</a>
                    </li>`;
        const items = [];
        if (totalPages <= 7) {
            for (let i = 1; i <= totalPages; i++) items.push(i);
        } else {
            items.push(1);
            if (page > 4) items.push('...');
            const start = Math.max(2, page - 1);
            const end = Math.min(totalPages - 1, page + 1);
            for (let i = start; i <= end; i++) items.push(i);
            if (page < totalPages - 3) items.push('...');
            if (totalPages !== 1 && items[items.length - 1] !== totalPages) items.push(totalPages);
        }
        for (const item of items) {
            if (item === '...') {
                pagination += '<li class="page-item disabled"><a class="page-link" href="javascript:void(0)">...</a></li>';
            } else {
                pagination += `<li class="page-item ${item === page ? 'active' : ''}">
                                    <a class="page-link" href="javascript:void(0)" onclick="MySearch.goToPage(${item})">${item}</a>
                                </li>`;
            }
        }
        pagination += `
                    <li class="page-item ${page === totalPages ? 'disabled' : ''}">
                        <a class="page-link" href="javascript:void(0)" onclick="MySearch.goToPage(${page + 1})">下一页</a>
                    </li>
                </ul>
                <div class="pagination d-flex align-items-center text-center ms-3 mb-3">
                    <div class="input-group input-group-sm">
                        <input id="page-input" type="number" min="1" class="form-control" max="${totalPages}" value="${page}" />
                        <button class="btn btn-sm btn-primary" onclick="MySearch.jumpToPage()">跳转</button>
                    </div>
                </div>
            </nav>`;
        return pagination;
    };

    // ======================== 搜索跳转链接 ========================
    app.goToSearchPage = function (options = {}) {
        return function (value) {
            const baseUrl = `${app.context_path}/search?s=${value}`;
            let link = `<a target="_blank" href="${baseUrl}">${value}</a>`;
            if (options.esLink) {
                link += `<a target="_blank" class="ms-2" href="${app.eastmoneyLink(value)}">东财</a>`;
            }
            if (options.kline) {
                link += `<a target="_blank" class="ms-2" href="${app.klineLink(value)}">K线图</a>`;
            }
            if (options.analysis) {
                link += `<a target="_blank" class="ms-2" href="${app.context_path}/quant/fundFlowAnalysis/analysis?qc=${value}">K线图</a>`;
            }
            return link;
        };
    };

    /** 选择input值 */
    app.chooseInputValue = function (el, name, value) {
        const $group = $(el).closest('.input-group');
        const $input = $group.find('input[name="' + name + '"]');
        $input.val(value);
    }

    return app;

})(window.MyApp, window, document, jQuery);
